// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file cortado/v1/inquiries.proto (package cortado.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Contact } from "./contacts_pb";
import { file_cortado_v1_contacts } from "./contacts_pb";
import type { EmailMessageDirection } from "./emails_pb";
import { file_cortado_v1_emails } from "./emails_pb";
import type { LineItemImage, QuoteAddonOffer, QuoteEvent, QuoteLineItem, QuotePaymentSchedule } from "./invoices_pb";
import { file_cortado_v1_invoices } from "./invoices_pb";
import type { OrganizationTipSelectorSettings } from "./organizations_pb";
import { file_cortado_v1_organizations } from "./organizations_pb";
import type { Questionnaire } from "./questionnaires_pb";
import { file_cortado_v1_questionnaires } from "./questionnaires_pb";
import type { BookingStageEnum, DiscountTypeEnum, EventStageEnum, EventTypeEnum, InquiryRejectReasonEnum, InquiryStageEnum, InquiryTagEnum, PaymentIntentStatusEnum, PaymentScheduleStatusEnum, PaymentStatusEnum, PortalAttributionModeEnum, QuoteStatusEnum, TipAllocationModeEnum, UserSchedulingRoleEnum, UserSchedulingStatusEnum } from "./settings_pb";
import { file_cortado_v1_settings } from "./settings_pb";
import type { User } from "./users_pb";
import { file_cortado_v1_users } from "./users_pb";
import type { FieldMask, Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_field_mask, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file cortado/v1/inquiries.proto.
 */
export const file_cortado_v1_inquiries: GenFile = /*@__PURE__*/
  fileDesc("Chpjb3J0YWRvL3YxL2lucXVpcmllcy5wcm90bxIKY29ydGFkby52MSKWDgoHSW5xdWlyeRIKCgJpZBgBIAEoCRIXCg9vcmdhbml6YXRpb25faWQYAiABKAkSEgoKY29udGFjdF9pZBgDIAEoCRIrCgVzdGFnZRgEIAEoDjIcLmNvcnRhZG8udjEuSW5xdWlyeVN0YWdlRW51bRI2CgpldmVudF90eXBlGAUgASgOMhkuY29ydGFkby52MS5FdmVudFR5cGVFbnVtQgIYAUgAiAEBEhsKDmV2ZW50X3R5cGVfa2V5GAYgASgJSAGIAQESFwoKZXZlbnRfZGF5cxgHIAEoBUgCiAEBEhsKDmV2ZW50X2xvY2F0aW9uGAkgASgJSAOIAQESFQoIcmVmZXJyZXIYDCABKAlIBIgBARIoCgZldmVudHMYUCADKAsyGC5jb3J0YWRvLnYxLklucXVpcnlFdmVudBIuCgpjcmVhdGVkX2F0GA0gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgpjcmVhdGVkX2J5GA4gASgJEi4KCnVwZGF0ZWRfYXQYDyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhIKCnVwZGF0ZWRfYnkYECABKAkSNAoLYXJjaGl2ZWRfYXQYMiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAWIAQESGAoLYXJjaGl2ZWRfYnkYMyABKAlIBogBARIpCgdjb250YWN0GBQgASgLMhMuY29ydGFkby52MS5Db250YWN0SAeIAQESLgoPY3JlYXRlZF9ieV91c2VyGBUgASgLMhAuY29ydGFkby52MS5Vc2VySAiIAQESLgoPdXBkYXRlZF9ieV91c2VyGBYgASgLMhAuY29ydGFkby52MS5Vc2VySAmIAQESEAoIbm90ZV9pZHMYHiADKAkSEAoIdGFza19pZHMYHyADKAkSEQoJcXVvdGVfaWRzGCAgAygJEhAKCGl0ZW1faWRzGDwgAygJEhgKC3F1b3RlX3RvdGFsGCggASgCSAqIAQESGwoOcXVvdGVfc3VidG90YWwYKSABKAJIC4gBARIWCglxdW90ZV90YXgYKiABKAJIDIgBARITCgtub3Rlc19jb3VudBgrIAEoBRITCgt0YXNrc19jb3VudBgsIAEoBRIUCgxxdW90ZXNfY291bnQYLSABKAUSEwoLaXRlbXNfY291bnQYLiABKAUSFwoKYm9va2luZ19pZBhGIAEoCUgNiAEBEhEKCWV2ZW50X2lkcxhHIAMoCRIoCgR0YWdzGEggAygOMhouY29ydGFkby52MS5JbnF1aXJ5VGFnRW51bRITCgZzb3VyY2UYUSABKAlIDogBARI/Cg1yZWplY3RfcmVhc29uGFIgASgOMiMuY29ydGFkby52MS5JbnF1aXJ5UmVqZWN0UmVhc29uRW51bUgPiAEBEhkKDHJlamVjdF9ub3RlcxhTIAEoCUgQiAEBEhgKC2Fzc2lnbmVkX3RvGFQgASgJSBGIAQESLwoQYXNzaWduZWRfdG9fdXNlchhVIAEoCzIQLmNvcnRhZG8udjEuVXNlckgSiAEBEh4KFnJlcXVpcmVzX3F1ZXN0aW9ubmFpcmUYViABKAgSEwoGam9iX2lkGFcgASgJSBOIAQESOAoPbGFzdF9pbmJvdW5kX2F0GFggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgUiAEBEjkKEGxhc3Rfb3V0Ym91bmRfYXQYWSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSBWIAQESRgoWbGFzdF9tZXNzYWdlX2RpcmVjdGlvbhhaIAEoDjIhLmNvcnRhZG8udjEuRW1haWxNZXNzYWdlRGlyZWN0aW9uSBaIAQFCDQoLX2V2ZW50X3R5cGVCEQoPX2V2ZW50X3R5cGVfa2V5Qg0KC19ldmVudF9kYXlzQhEKD19ldmVudF9sb2NhdGlvbkILCglfcmVmZXJyZXJCDgoMX2FyY2hpdmVkX2F0Qg4KDF9hcmNoaXZlZF9ieUIKCghfY29udGFjdEISChBfY3JlYXRlZF9ieV91c2VyQhIKEF91cGRhdGVkX2J5X3VzZXJCDgoMX3F1b3RlX3RvdGFsQhEKD19xdW90ZV9zdWJ0b3RhbEIMCgpfcXVvdGVfdGF4Qg0KC19ib29raW5nX2lkQgkKB19zb3VyY2VCEAoOX3JlamVjdF9yZWFzb25CDwoNX3JlamVjdF9ub3Rlc0IOCgxfYXNzaWduZWRfdG9CEwoRX2Fzc2lnbmVkX3RvX3VzZXJCCQoHX2pvYl9pZEISChBfbGFzdF9pbmJvdW5kX2F0QhMKEV9sYXN0X291dGJvdW5kX2F0QhkKF19sYXN0X21lc3NhZ2VfZGlyZWN0aW9uIpcMCgtJbnF1aXJ5TGl0ZRIKCgJpZBgBIAEoCRIXCg9vcmdhbml6YXRpb25faWQYAiABKAkSKwoFc3RhZ2UYAyABKA4yHC5jb3J0YWRvLnYxLklucXVpcnlTdGFnZUVudW0SNgoKZXZlbnRfdHlwZRgNIAEoDjIZLmNvcnRhZG8udjEuRXZlbnRUeXBlRW51bUICGAFIAIgBARIbCg5ldmVudF90eXBlX2tleRgOIAEoCUgBiAEBEhIKCmNvbnRhY3RfaWQYFCABKAkSGgoSY29udGFjdF9maXJzdF9uYW1lGBUgASgJEhkKEWNvbnRhY3RfbGFzdF9uYW1lGBYgASgJEhgKC3F1b3RlX3RvdGFsGB4gASgCSAKIAQESJwoaYWNjZXB0ZWRfcXVvdGVfdG90YWxfY2VudHMYHyABKANIA4gBARIuCgpjcmVhdGVkX2F0GCggASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GCkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIXCgpib29raW5nX2lkGDIgASgJSASIAQESNAoLYXJjaGl2ZWRfYXQYMyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAWIAQESGAoLYXJjaGl2ZWRfYnkYNCABKAlIBogBARI5ChBmaXJzdF9ldmVudF9kYXRlGDwgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgHiAEBEhQKDGV2ZW50c19jb3VudBg9IAEoBRI4Cg9sYXN0X2V2ZW50X2RhdGUYPiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAiIAQESGQoRdG90YWxfZ3Vlc3RfY291bnQYPyABKAUSIQoUZmlyc3RfZXZlbnRfdGltZXpvbmUYQiABKAlICYgBARIoCgR0YWdzGEAgAygOMhouY29ydGFkby52MS5JbnF1aXJ5VGFnRW51bRIwCg5pbnF1aXJ5X2V2ZW50cxhBIAMoCzIYLmNvcnRhZG8udjEuSW5xdWlyeUV2ZW50EiEKFGNvbnRhY3RfY29tcGFueV9uYW1lGEYgASgJSAqIAQESEwoGc291cmNlGEcgASgJSAuIAQESGAoLYXNzaWduZWRfdG8YSCABKAlIDIgBARIjChZhc3NpZ25lZF90b19maXJzdF9uYW1lGEkgASgJSA2IAQESIgoVYXNzaWduZWRfdG9fbGFzdF9uYW1lGEogASgJSA6IAQESEwoGam9iX2lkGEsgASgJSA+IAQESOAoPbGFzdF9pbmJvdW5kX2F0GEwgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgQiAEBEjkKEGxhc3Rfb3V0Ym91bmRfYXQYTSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSBGIAQESRgoWbGFzdF9tZXNzYWdlX2RpcmVjdGlvbhhOIAEoDjIhLmNvcnRhZG8udjEuRW1haWxNZXNzYWdlRGlyZWN0aW9uSBKIAQFCDQoLX2V2ZW50X3R5cGVCEQoPX2V2ZW50X3R5cGVfa2V5Qg4KDF9xdW90ZV90b3RhbEIdChtfYWNjZXB0ZWRfcXVvdGVfdG90YWxfY2VudHNCDQoLX2Jvb2tpbmdfaWRCDgoMX2FyY2hpdmVkX2F0Qg4KDF9hcmNoaXZlZF9ieUITChFfZmlyc3RfZXZlbnRfZGF0ZUISChBfbGFzdF9ldmVudF9kYXRlQhcKFV9maXJzdF9ldmVudF90aW1lem9uZUIXChVfY29udGFjdF9jb21wYW55X25hbWVCCQoHX3NvdXJjZUIOCgxfYXNzaWduZWRfdG9CGQoXX2Fzc2lnbmVkX3RvX2ZpcnN0X25hbWVCGAoWX2Fzc2lnbmVkX3RvX2xhc3RfbmFtZUIJCgdfam9iX2lkQhIKEF9sYXN0X2luYm91bmRfYXRCEwoRX2xhc3Rfb3V0Ym91bmRfYXRCGQoXX2xhc3RfbWVzc2FnZV9kaXJlY3Rpb24imQsKB0Jvb2tpbmcSCgoCaWQYASABKAkSFwoPb3JnYW5pemF0aW9uX2lkGAIgASgJEhcKCmlucXVpcnlfaWQYAyABKAlIAIgBARISCgpjb250YWN0X2lkGAQgASgJEisKBXN0YWdlGAUgASgOMhwuY29ydGFkby52MS5Cb29raW5nU3RhZ2VFbnVtEjYKCmV2ZW50X3R5cGUYBiABKA4yGS5jb3J0YWRvLnYxLkV2ZW50VHlwZUVudW1CAhgBSAGIAQESGwoOZXZlbnRfdHlwZV9rZXkYDiABKAlIAogBARI1Cg1xdWVzdGlvbm5haXJlGA8gASgLMhkuY29ydGFkby52MS5RdWVzdGlvbm5haXJlSAOIAQESGAoLZXZlbnRfc3RhdGUYCCABKAlIBIgBARIZCgxldmVudF9jb3VudHkYCSABKAlIBYgBARIuCgpjcmVhdGVkX2F0GAogASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgpjcmVhdGVkX2J5GAsgASgJEi4KCnVwZGF0ZWRfYXQYDCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhIKCnVwZGF0ZWRfYnkYDSABKAkSLgoPY3JlYXRlZF9ieV91c2VyGBUgASgLMhAuY29ydGFkby52MS5Vc2VySAaIAQESLgoPdXBkYXRlZF9ieV91c2VyGBYgASgLMhAuY29ydGFkby52MS5Vc2VySAeIAQESEAoIbm90ZV9pZHMYHiADKAkSEAoIdGFza19pZHMYHyADKAkSEQoJZXZlbnRfaWRzGCAgAygJEhMKC2ludm9pY2VfaWRzGCEgAygJEhwKFHRvdGFsX2ludm9pY2VfYW1vdW50GCggASgCEhIKCnRvdGFsX3BhaWQYKSABKAISEQoJdG90YWxfZHVlGCogASgCEhQKDGV2ZW50c19jb3VudBgrIAEoBRIWCg5pbnZvaWNlc19jb3VudBgsIAEoBRITCgtub3Rlc19jb3VudBgtIAEoBRITCgt0YXNrc19jb3VudBguIAEoBRITCgZqb2JfaWQYLyABKAlICIgBARI4Cg9sYXN0X2luYm91bmRfYXQYMCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAmIAQESOQoQbGFzdF9vdXRib3VuZF9hdBgxIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBICogBARJGChZsYXN0X21lc3NhZ2VfZGlyZWN0aW9uGDIgASgOMiEuY29ydGFkby52MS5FbWFpbE1lc3NhZ2VEaXJlY3Rpb25IC4gBARI+ChVxdWVzdGlvbm5haXJlX3NlbnRfYXQYMyABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAyIAQESQgoZcXVlc3Rpb25uYWlyZV9yZXR1cm5lZF9hdBg0IAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIDYgBAUINCgtfaW5xdWlyeV9pZEINCgtfZXZlbnRfdHlwZUIRCg9fZXZlbnRfdHlwZV9rZXlCEAoOX3F1ZXN0aW9ubmFpcmVCDgoMX2V2ZW50X3N0YXRlQg8KDV9ldmVudF9jb3VudHlCEgoQX2NyZWF0ZWRfYnlfdXNlckISChBfdXBkYXRlZF9ieV91c2VyQgkKB19qb2JfaWRCEgoQX2xhc3RfaW5ib3VuZF9hdEITChFfbGFzdF9vdXRib3VuZF9hdEIZChdfbGFzdF9tZXNzYWdlX2RpcmVjdGlvbkIYChZfcXVlc3Rpb25uYWlyZV9zZW50X2F0QhwKGl9xdWVzdGlvbm5haXJlX3JldHVybmVkX2F0SgQIBxAIUg5ldmVudF9sb2NhdGlvbiLBCwoFRXZlbnQSCgoCaWQYASABKAkSFwoPb3JnYW5pemF0aW9uX2lkGAIgASgJEhIKCmNvbnRhY3RfaWQYAyABKAkSEgoKYm9va2luZ19pZBgEIAEoCRIpCgVzdGFnZRgFIAEoDjIaLmNvcnRhZG8udjEuRXZlbnRTdGFnZUVudW0SMwoKZXZlbnRfZGF0ZRgGIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBARIZCgxldmVudF9sZW5ndGgYByABKAFIAYgBARIZCgxldmVudF9ndWVzdHMYCCABKAVIAogBARIbCg5ldmVudF90aW1lem9uZRgJIAEoCUgDiAEBEhgKC2NhbGVuZGFyX2lkGAogASgJSASIAQESNgoKZXZlbnRfdHlwZRgPIAEoDjIZLmNvcnRhZG8udjEuRXZlbnRUeXBlRW51bUICGAFIBYgBARIbCg5ldmVudF90eXBlX2tleRgTIAEoCUgGiAEBEhsKDmV2ZW50X2xvY2F0aW9uGBAgASgJSAeIAQESGgoNYmFyaXN0YV9jb3VudBgRIAEoBUgIiAEBEhcKCmNhcnRfY291bnQYEiABKAVICYgBARIuCgpjcmVhdGVkX2F0GAsgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgpjcmVhdGVkX2J5GAwgASgJEi4KCnVwZGF0ZWRfYXQYDSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhIKCnVwZGF0ZWRfYnkYDiABKAkSNAoLYXJjaGl2ZWRfYXQYMiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAqIAQESGAoLYXJjaGl2ZWRfYnkYMyABKAlIC4gBARIpCgdjb250YWN0GBQgASgLMhMuY29ydGFkby52MS5Db250YWN0SAyIAQESLgoPY3JlYXRlZF9ieV91c2VyGBUgASgLMhAuY29ydGFkby52MS5Vc2VySA2IAQESLgoPdXBkYXRlZF9ieV91c2VyGBYgASgLMhAuY29ydGFkby52MS5Vc2VySA6IAQESGwoTdXNlcl9zY2hlZHVsaW5nX2lkcxgeIAMoCRIQCghub3RlX2lkcxgfIAMoCRIQCgh0YXNrX2lkcxggIAMoCRIdChVzY2hlZHVsZWRfdXNlcnNfY291bnQYKCABKAUSIQoUY2FsZW5kYXJfc3luY19zdGF0dXMYKSABKAlID4gBARI7ChJjYWxlbmRhcl9zeW5jZWRfYXQYKiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSBCIAQESIAoTY2FsZW5kYXJfc3luY19lcnJvchgrIAEoCUgRiAEBEioKHWNhbGVuZGFyX2Rlc2NyaXB0aW9uX292ZXJyaWRlGCwgASgJSBKIAQESEwoGam9iX2lkGC0gASgJSBOIAQFCDQoLX2V2ZW50X2RhdGVCDwoNX2V2ZW50X2xlbmd0aEIPCg1fZXZlbnRfZ3Vlc3RzQhEKD19ldmVudF90aW1lem9uZUIOCgxfY2FsZW5kYXJfaWRCDQoLX2V2ZW50X3R5cGVCEQoPX2V2ZW50X3R5cGVfa2V5QhEKD19ldmVudF9sb2NhdGlvbkIQCg5fYmFyaXN0YV9jb3VudEINCgtfY2FydF9jb3VudEIOCgxfYXJjaGl2ZWRfYXRCDgoMX2FyY2hpdmVkX2J5QgoKCF9jb250YWN0QhIKEF9jcmVhdGVkX2J5X3VzZXJCEgoQX3VwZGF0ZWRfYnlfdXNlckIXChVfY2FsZW5kYXJfc3luY19zdGF0dXNCFQoTX2NhbGVuZGFyX3N5bmNlZF9hdEIWChRfY2FsZW5kYXJfc3luY19lcnJvckIgCh5fY2FsZW5kYXJfZGVzY3JpcHRpb25fb3ZlcnJpZGVCCQoHX2pvYl9pZCKbBwoJRXZlbnRMaXRlEgoKAmlkGAEgASgJEhcKD29yZ2FuaXphdGlvbl9pZBgCIAEoCRISCgpib29raW5nX2lkGAMgASgJEikKBXN0YWdlGAQgASgOMhouY29ydGFkby52MS5FdmVudFN0YWdlRW51bRIzCgpldmVudF9kYXRlGAogASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBEhkKDGV2ZW50X2xlbmd0aBgLIAEoAUgBiAEBEhkKDGV2ZW50X2d1ZXN0cxgMIAEoBUgCiAEBEhsKDmV2ZW50X3RpbWV6b25lGA0gASgJSAOIAQESFwoKaW5xdWlyeV9pZBgOIAEoCUgEiAEBEjYKCmV2ZW50X3R5cGUYDyABKA4yGS5jb3J0YWRvLnYxLkV2ZW50VHlwZUVudW1CAhgBSAWIAQESGwoOZXZlbnRfdHlwZV9rZXkYEyABKAlIBogBARIbCg5ldmVudF9sb2NhdGlvbhgQIAEoCUgHiAEBEhoKDWJhcmlzdGFfY291bnQYESABKAVICIgBARIXCgpjYXJ0X2NvdW50GBIgASgFSAmIAQESEgoKY29udGFjdF9pZBgUIAEoCRIaChJjb250YWN0X2ZpcnN0X25hbWUYFSABKAkSGQoRY29udGFjdF9sYXN0X25hbWUYFiABKAkSNAoLYXJjaGl2ZWRfYXQYMiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAqIAQESGAoLYXJjaGl2ZWRfYnkYMyABKAlIC4gBARIuCgpjcmVhdGVkX2F0GB4gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBIuCgp1cGRhdGVkX2F0GB8gASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBITCgZqb2JfaWQYICABKAlIDIgBAUINCgtfZXZlbnRfZGF0ZUIPCg1fZXZlbnRfbGVuZ3RoQg8KDV9ldmVudF9ndWVzdHNCEQoPX2V2ZW50X3RpbWV6b25lQg0KC19pbnF1aXJ5X2lkQg0KC19ldmVudF90eXBlQhEKD19ldmVudF90eXBlX2tleUIRCg9fZXZlbnRfbG9jYXRpb25CEAoOX2JhcmlzdGFfY291bnRCDQoLX2NhcnRfY291bnRCDgoMX2FyY2hpdmVkX2F0Qg4KDF9hcmNoaXZlZF9ieUIJCgdfam9iX2lkIpAECgxJbnF1aXJ5RXZlbnQSCgoCaWQYASABKAkSFwoPb3JnYW5pemF0aW9uX2lkGAIgASgJEhIKCmlucXVpcnlfaWQYAyABKAkSMwoKZXZlbnRfZGF0ZRgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBARIZCgxldmVudF9sZW5ndGgYBSABKAFIAYgBARIZCgxldmVudF9ndWVzdHMYBiABKAVIAogBARIbCg5ldmVudF90aW1lem9uZRgHIAEoCUgDiAEBEjYKCmV2ZW50X3R5cGUYCCABKA4yGS5jb3J0YWRvLnYxLkV2ZW50VHlwZUVudW1CAhgBSASIAQESGwoOZXZlbnRfdHlwZV9rZXkYDCABKAlIBYgBARIbCg5ldmVudF9sb2NhdGlvbhgJIAEoCUgGiAEBEhoKDWJhcmlzdGFfY291bnQYCiABKAVIB4gBARIXCgpjYXJ0X2NvdW50GAsgASgFSAiIAQFCDQoLX2V2ZW50X2RhdGVCDwoNX2V2ZW50X2xlbmd0aEIPCg1fZXZlbnRfZ3Vlc3RzQhEKD19ldmVudF90aW1lem9uZUINCgtfZXZlbnRfdHlwZUIRCg9fZXZlbnRfdHlwZV9rZXlCEQoPX2V2ZW50X2xvY2F0aW9uQhAKDl9iYXJpc3RhX2NvdW50Qg0KC19jYXJ0X2NvdW50ItoECg5Vc2VyU2NoZWR1bGluZxIKCgJpZBgBIAEoCRIQCghldmVudF9pZBgCIAEoCRIPCgd1c2VyX2lkGAMgASgJEjAKDHNjaGVkdWxlZF9hdBgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASEAoIZHVyYXRpb24YBSABKAESNAoGc3RhdHVzGAYgASgOMiQuY29ydGFkby52MS5Vc2VyU2NoZWR1bGluZ1N0YXR1c0VudW0SMAoEcm9sZRgMIAEoDjIiLmNvcnRhZG8udjEuVXNlclNjaGVkdWxpbmdSb2xlRW51bRIuCgpjcmVhdGVkX2F0GAcgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcBISCgpjcmVhdGVkX2J5GAggASgJEi4KCnVwZGF0ZWRfYXQYCSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhIKCnVwZGF0ZWRfYnkYCiABKAkSIwoEdXNlchgLIAEoCzIQLmNvcnRhZG8udjEuVXNlckgAiAEBEi4KD2NyZWF0ZWRfYnlfdXNlchgUIAEoCzIQLmNvcnRhZG8udjEuVXNlckgBiAEBEi4KD3VwZGF0ZWRfYnlfdXNlchgVIAEoCzIQLmNvcnRhZG8udjEuVXNlckgCiAEBEiUKBWV2ZW50GBYgASgLMhEuY29ydGFkby52MS5FdmVudEgDiAEBQgcKBV91c2VyQhIKEF9jcmVhdGVkX2J5X3VzZXJCEgoQX3VwZGF0ZWRfYnlfdXNlckIICgZfZXZlbnQi3gQKDVB1YmxpY0lucXVpcnkSCgoCaWQYASABKAkSKwoFc3RhZ2UYAiABKA4yHC5jb3J0YWRvLnYxLklucXVpcnlTdGFnZUVudW0SNgoKZXZlbnRfdHlwZRgKIAEoDjIZLmNvcnRhZG8udjEuRXZlbnRUeXBlRW51bUICGAFIAIgBARIbCg5ldmVudF90eXBlX2tleRgLIAEoCUgBiAEBEhcKCmV2ZW50X2RheXMYDCABKAVIAogBARIbCg5ldmVudF9sb2NhdGlvbhgOIAEoCUgDiAEBEhoKEmNvbnRhY3RfZmlyc3RfbmFtZRgUIAEoCRIZChFjb250YWN0X2xhc3RfbmFtZRgVIAEoCRIlCgVpdGVtcxgeIAMoCzIWLmNvcnRhZG8udjEuUHVibGljSXRlbRInCgZxdW90ZXMYKCADKAsyFy5jb3J0YWRvLnYxLlB1YmxpY1F1b3RlEjQKDG9yZ2FuaXphdGlvbhgyIAEoCzIeLmNvcnRhZG8udjEuUHVibGljT3JnYW5pemF0aW9uEi4KCmNyZWF0ZWRfYXQYPCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEi4KCnVwZGF0ZWRfYXQYPSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEigKBmV2ZW50cxhGIAMoCzIYLmNvcnRhZG8udjEuSW5xdWlyeUV2ZW50Qg0KC19ldmVudF90eXBlQhEKD19ldmVudF90eXBlX2tleUINCgtfZXZlbnRfZGF5c0IRCg9fZXZlbnRfbG9jYXRpb24iUQoKUHVibGljSXRlbRIKCgJpZBgBIAEoCRINCgV0aXRsZRgCIAEoCRIYCgtkZXNjcmlwdGlvbhgDIAEoCUgAiAEBQg4KDF9kZXNjcmlwdGlvbiLXCwoLUHVibGljUXVvdGUSCgoCaWQYASABKAkSFAoMcXVvdGVfbnVtYmVyGAIgASgFEg0KBXRpdGxlGAMgASgJEhgKC2Rlc2NyaXB0aW9uGAQgASgJSACIAQESNAoLdmFsaWRfdW50aWwYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSAGIAQESLQoKbGluZV9pdGVtcxgKIAMoCzIZLmNvcnRhZG8udjEuUXVvdGVMaW5lSXRlbRIWCg5zdWJ0b3RhbF9jZW50cxgUIAEoAxIXCg9zYWxlc190YXhfY2VudHMYFSABKAMSFgoOZGlzY291bnRfY2VudHMYFiABKAMSHwoSZW5mb3JjZWRfdGlwX2NlbnRzGBcgASgDSAKIAQESEwoLdG90YWxfY2VudHMYGCABKAMSJAoXZW5mb3JjZWRfdGlwX3BlcmNlbnRhZ2UYGSABKAFIA4gBARIcChR0b3RhbF93aXRoX3RpcF9jZW50cxhMIAEoAxIaCg1kaXNjb3VudF9uYW1lGB4gASgJSASIAQESOAoNZGlzY291bnRfdHlwZRgfIAEoDjIcLmNvcnRhZG8udjEuRGlzY291bnRUeXBlRW51bUgFiAEBEhsKDmRpc2NvdW50X3ZhbHVlGCAgASgBSAaIAQESMwoKZXZlbnRfZGF0ZRgjIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIB4gBARIbCg5ldmVudF9sb2NhdGlvbhgkIAEoCUgIiAEBEhgKC2d1ZXN0X2NvdW50GCUgASgFSAmIAQESGwoOZXZlbnRfZHVyYXRpb24YJiABKAFICogBARIrCgZzdGF0dXMYKCABKA4yGy5jb3J0YWRvLnYxLlF1b3RlU3RhdHVzRW51bRIwCgdzZW50X2F0GCkgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgLiAEBEjIKCXZpZXdlZF9hdBgqIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIDIgBARI0CgthY2NlcHRlZF9hdBgrIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIDYgBARI7ChFwYXltZW50X3NjaGVkdWxlcxgyIAMoCzIgLmNvcnRhZG8udjEuUXVvdGVQYXltZW50U2NoZWR1bGUSLgoKY3JlYXRlZF9hdBg8IAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLgoKdXBkYXRlZF9hdBg9IAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASFwoKYm9va2luZ19pZBhGIAEoCUgOiAEBEiwKDHF1b3RlX2V2ZW50cxhHIAMoCzIWLmNvcnRhZG8udjEuUXVvdGVFdmVudBIxCgxhZGRvbl9vZmZlcnMYSSADKAsyGy5jb3J0YWRvLnYxLlF1b3RlQWRkb25PZmZlchIcChRxdW90ZV9hZGRvbnNfZW5hYmxlZBhKIAEoCBITCgtyZXZpc2lvbl9pZBhLIAEoCRI+ChN0aXBfYWxsb2NhdGlvbl9tb2RlGE0gASgOMiEuY29ydGFkby52MS5UaXBBbGxvY2F0aW9uTW9kZUVudW1CDgoMX2Rlc2NyaXB0aW9uQg4KDF92YWxpZF91bnRpbEIVChNfZW5mb3JjZWRfdGlwX2NlbnRzQhoKGF9lbmZvcmNlZF90aXBfcGVyY2VudGFnZUIQCg5fZGlzY291bnRfbmFtZUIQCg5fZGlzY291bnRfdHlwZUIRCg9fZGlzY291bnRfdmFsdWVCDQoLX2V2ZW50X2RhdGVCEQoPX2V2ZW50X2xvY2F0aW9uQg4KDF9ndWVzdF9jb3VudEIRCg9fZXZlbnRfZHVyYXRpb25CCgoIX3NlbnRfYXRCDAoKX3ZpZXdlZF9hdEIOCgxfYWNjZXB0ZWRfYXRCDQoLX2Jvb2tpbmdfaWQiwQIKElB1YmxpY09yZ2FuaXphdGlvbhIKCgJpZBgBIAEoCRIMCgRuYW1lGAIgASgJEhUKCGxvZ29fdXJsGAMgASgJSACIAQESGAoLd2Vic2l0ZV91cmwYBCABKAlIAYgBARIaCg1jb250YWN0X2VtYWlsGAUgASgJSAKIAQESLwoKYWdyZWVtZW50cxgGIAMoCzIbLmNvcnRhZG8udjEuUHVibGljQWdyZWVtZW50EiwKJHJlcXVpcmVfcXVlc3Rpb25uYWlyZV9iZWZvcmVfcGF5bWVudBgHIAEoCBI2Cg5nYWxsZXJ5X2ltYWdlcxgIIAMoCzIeLmNvcnRhZG8udjEuUHVibGljR2FsbGVyeUltYWdlQgsKCV9sb2dvX3VybEIOCgxfd2Vic2l0ZV91cmxCEAoOX2NvbnRhY3RfZW1haWwifQoSUHVibGljR2FsbGVyeUltYWdlEgsKA3VybBgBIAEoCRIQCghhbHRfdGV4dBgCIAEoCRIVCgh3aWR0aF9weBgDIAEoBUgAiAEBEhYKCWhlaWdodF9weBgEIAEoBUgBiAEBQgsKCV93aWR0aF9weEIMCgpfaGVpZ2h0X3B4Im0KD1B1YmxpY0FncmVlbWVudBIKCgJpZBgBIAEoCRIMCgR0eXBlGAIgASgJEgwKBG5hbWUYAyABKAkSMgoHY2xhdXNlcxgEIAMoCzIhLmNvcnRhZG8udjEuUHVibGljQWdyZWVtZW50Q2xhdXNlIlcKFVB1YmxpY0FncmVlbWVudENsYXVzZRIKCgJpZBgBIAEoCRINCgV0aXRsZRgCIAEoCRIMCgRib2R5GAMgASgJEhUKDWRpc3BsYXlfb3JkZXIYBCABKAUiNgoNUHVibGljQ29udGFjdBISCgpmaXJzdF9uYW1lGAEgASgJEhEKCWxhc3RfbmFtZRgCIAEoCSKGBAoNUHVibGljQm9va2luZxIKCgJpZBgBIAEoCRISCgppbnF1aXJ5X2lkGAIgASgJEjQKDG9yZ2FuaXphdGlvbhgKIAEoCzIeLmNvcnRhZG8udjEuUHVibGljT3JnYW5pemF0aW9uEioKB2NvbnRhY3QYCyABKAsyGS5jb3J0YWRvLnYxLlB1YmxpY0NvbnRhY3QSKwoFc3RhZ2UYFCABKA4yHC5jb3J0YWRvLnYxLkJvb2tpbmdTdGFnZUVudW0SNgoKZXZlbnRfdHlwZRgVIAEoDjIZLmNvcnRhZG8udjEuRXZlbnRUeXBlRW51bUICGAFIAIgBARIdChBldmVudF90eXBlX2xhYmVsGBcgASgJSAGIAQESGwoOZXZlbnRfdHlwZV9rZXkYGCABKAlIAogBARI1Cg1xdWVzdGlvbm5haXJlGBkgASgLMhkuY29ydGFkby52MS5RdWVzdGlvbm5haXJlSAOIAQESJwoGZXZlbnRzGB4gAygLMhcuY29ydGFkby52MS5QdWJsaWNFdmVudBITCgtpbnZvaWNlX2lkcxgoIAMoCUINCgtfZXZlbnRfdHlwZUITChFfZXZlbnRfdHlwZV9sYWJlbEIRCg9fZXZlbnRfdHlwZV9rZXlCEAoOX3F1ZXN0aW9ubmFpcmVKBAgWEBdSDmV2ZW50X2xvY2F0aW9uIpUCCgtQdWJsaWNFdmVudBIKCgJpZBgBIAEoCRIzCgpldmVudF9kYXRlGAogASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBEhsKDmV2ZW50X2xvY2F0aW9uGAsgASgJSAGIAQESGQoMZXZlbnRfbGVuZ3RoGAwgASgBSAKIAQESGQoMZXZlbnRfZ3Vlc3RzGA0gASgFSAOIAQESGwoOZXZlbnRfdGltZXpvbmUYDiABKAlIBIgBAUINCgtfZXZlbnRfZGF0ZUIRCg9fZXZlbnRfbG9jYXRpb25CDwoNX2V2ZW50X2xlbmd0aEIPCg1fZXZlbnRfZ3Vlc3RzQhEKD19ldmVudF90aW1lem9uZSKvCQoNUHVibGljSW52b2ljZRIKCgJpZBgBIAEoCRISCgV0aXRsZRgCIAEoCUgAiAEBEhYKDmludm9pY2VfbnVtYmVyGAMgASgFEhgKC2Rlc2NyaXB0aW9uGAogASgJSAGIAQESFgoOc3VidG90YWxfY2VudHMYFCABKAMSEQoJdGF4X2NlbnRzGBUgASgDEhYKDmRpc2NvdW50X2NlbnRzGBYgASgDEhMKC3RvdGFsX2NlbnRzGBcgASgDEhkKEWFtb3VudF9wYWlkX2NlbnRzGBggASgDEhkKEWJhbGFuY2VfZHVlX2NlbnRzGBkgASgDEhoKDWRpc2NvdW50X25hbWUYGiABKAlIAogBARI4Cg1kaXNjb3VudF90eXBlGBsgASgOMhwuY29ydGFkby52MS5EaXNjb3VudFR5cGVFbnVtSAOIAQESGwoOZGlzY291bnRfdmFsdWUYHCABKAFIBIgBARI1Cg5wYXltZW50X3N0YXR1cxgeIAEoDjIdLmNvcnRhZG8udjEuUGF5bWVudFN0YXR1c0VudW0SMAoHcGFpZF9hdBgfIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIBYgBARI1CgpsaW5lX2l0ZW1zGCggAygLMiEuY29ydGFkby52MS5QdWJsaWNJbnZvaWNlTGluZUl0ZW0SPAoRcGF5bWVudF9zY2hlZHVsZXMYMiADKAsyIS5jb3J0YWRvLnYxLlB1YmxpY1BheW1lbnRTY2hlZHVsZRI5Cgxvcmdhbml6YXRpb24YPCABKAsyHi5jb3J0YWRvLnYxLlB1YmxpY09yZ2FuaXphdGlvbkgGiAEBEhEKCXRpcF9jZW50cxhGIAEoAxIfChJlbmZvcmNlZF90aXBfY2VudHMYRyABKANIB4gBARIkChdlbmZvcmNlZF90aXBfcGVyY2VudGFnZRhIIAEoAUgIiAEBEhwKFGVuZm9yY2VkX3RpcF9lbmFibGVkGEkgASgIEk8KFXRpcF9zZWxlY3Rvcl9zZXR0aW5ncxhKIAEoCzIrLmNvcnRhZG8udjEuT3JnYW5pemF0aW9uVGlwU2VsZWN0b3JTZXR0aW5nc0gJiAEBEh8KF2dvb2R3aWxsX3JlZnVuZGVkX2NlbnRzGFAgASgDEhYKDnRpcF9wYWlkX2NlbnRzGFIgASgDEhUKDXRpcF9kdWVfY2VudHMYUyABKAMSHgoWdGlwX2FjY291bnRpbmdfdmVyc2lvbhhUIAEoBRI+ChN0aXBfYWxsb2NhdGlvbl9tb2RlGFUgASgOMiEuY29ydGFkby52MS5UaXBBbGxvY2F0aW9uTW9kZUVudW1CCAoGX3RpdGxlQg4KDF9kZXNjcmlwdGlvbkIQCg5fZGlzY291bnRfbmFtZUIQCg5fZGlzY291bnRfdHlwZUIRCg9fZGlzY291bnRfdmFsdWVCCgoIX3BhaWRfYXRCDwoNX29yZ2FuaXphdGlvbkIVChNfZW5mb3JjZWRfdGlwX2NlbnRzQhoKGF9lbmZvcmNlZF90aXBfcGVyY2VudGFnZUIYChZfdGlwX3NlbGVjdG9yX3NldHRpbmdzIuUCChVQdWJsaWNJbnZvaWNlTGluZUl0ZW0SDAoEbmFtZRgBIAEoCRIYCgtkZXNjcmlwdGlvbhgCIAEoCUgAiAEBEhAKCHF1YW50aXR5GAMgASgBEhgKEHVuaXRfcHJpY2VfY2VudHMYBCABKAMSGAoQbGluZV90b3RhbF9jZW50cxgFIAEoAxIMCgR1bml0GAYgASgJEhIKCmlzX3RheGFibGUYByABKAgSIAoTc2FsZXNfdGF4X3JhdGVfbmFtZRgIIAEoCUgBiAEBEhsKDnNhbGVzX3RheF9yYXRlGAkgASgBSAKIAQESFwoPc2FsZXNfdGF4X2NlbnRzGAogASgDEikKBmltYWdlcxgLIAMoCzIZLmNvcnRhZG8udjEuTGluZUl0ZW1JbWFnZUIOCgxfZGVzY3JpcHRpb25CFgoUX3NhbGVzX3RheF9yYXRlX25hbWVCEQoPX3NhbGVzX3RheF9yYXRlIqQFChVQdWJsaWNQYXltZW50U2NoZWR1bGUSCgoCaWQYASABKAkSFwoPc2VxdWVuY2VfbnVtYmVyGAIgASgFEhMKC2Rlc2NyaXB0aW9uGAMgASgJEjEKCGR1ZV9kYXRlGAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBEhQKDGFtb3VudF9jZW50cxgFIAEoAxIZChFhbW91bnRfcGFpZF9jZW50cxgGIAEoAxI1CgZzdGF0dXMYByABKA4yJS5jb3J0YWRvLnYxLlBheW1lbnRTY2hlZHVsZVN0YXR1c0VudW0SMAoHcGFpZF9hdBgIIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAYgBARIaChJoYXNfcGF5bWVudF9pbnRlbnQYCSABKAgSEgoKaXNfb3ZlcmR1ZRgKIAEoCBIWCg5pc19sYXN0X3VucGFpZBgLIAEoCBIiChVhbW91bnRfd2l0aF90aXBfY2VudHMYDCABKANIAogBARIkChdob3N0ZWRfdmVyaWZpY2F0aW9uX3VybBgNIAEoCUgDiAEBEhsKE2xhc3RfcGF5bWVudF9mYWlsZWQYDiABKAgSMQoIcGF5bWVudHMYFCADKAsyHy5jb3J0YWRvLnYxLlB1YmxpY1BheW1lbnRJbnRlbnQSHwoXZ29vZHdpbGxfcmVmdW5kZWRfY2VudHMYHiABKAMSGgoSZXhwZWN0ZWRfdGlwX2NlbnRzGB8gASgDEhYKDnRpcF9wYWlkX2NlbnRzGCAgASgDQgsKCV9kdWVfZGF0ZUIKCghfcGFpZF9hdEIYChZfYW1vdW50X3dpdGhfdGlwX2NlbnRzQhoKGF9ob3N0ZWRfdmVyaWZpY2F0aW9uX3VybCLcAgoTUHVibGljUGF5bWVudEludGVudBIKCgJpZBgBIAEoCRIUCgxhbW91bnRfY2VudHMYAiABKAMSMwoGc3RhdHVzGAMgASgOMiMuY29ydGFkby52MS5QYXltZW50SW50ZW50U3RhdHVzRW51bRIwCgdwYWlkX2F0GAQgASgLMhouZ29vZ2xlLnByb3RvYnVmLlRpbWVzdGFtcEgAiAEBEiAKE3BheW1lbnRfbWV0aG9kX3R5cGUYCiABKAlIAYgBARIhChRwYXltZW50X21ldGhvZF9sYXN0NBgLIAEoCUgCiAEBEiEKFHBheW1lbnRfbWV0aG9kX2JyYW5kGAwgASgJSAOIAQFCCgoIX3BhaWRfYXRCFgoUX3BheW1lbnRfbWV0aG9kX3R5cGVCFwoVX3BheW1lbnRfbWV0aG9kX2xhc3Q0QhcKFV9wYXltZW50X21ldGhvZF9icmFuZCL+AQoZR2VuZXJhdGVQb3J0YWxMaW5rUmVxdWVzdBISCgppbnF1aXJ5X2lkGAEgASgJEiEKEGV4cGlyZXNfaW5faG91cnMYAiABKANCAhgBSACIAQESFgoKb21pdF90b2tlbhgDIAEoCEICGAESRAoQYXR0cmlidXRpb25fbW9kZRgEIAEoDjIlLmNvcnRhZG8udjEuUG9ydGFsQXR0cmlidXRpb25Nb2RlRW51bUgBiAEBEhUKCHF1b3RlX2lkGAUgASgJSAKIAQFCEwoRX2V4cGlyZXNfaW5faG91cnNCEwoRX2F0dHJpYnV0aW9uX21vZGVCCwoJX3F1b3RlX2lkImwKGkdlbmVyYXRlUG9ydGFsTGlua1Jlc3BvbnNlEgsKA3VybBgBIAEoCRIRCgV0b2tlbhgCIAEoCUICGAESLgoKZXhwaXJlc19hdBgDIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiIQofR2VuZXJhdGVQdWJsaWNQb3J0YWxMaW5rUmVxdWVzdCJfCiBHZW5lcmF0ZVB1YmxpY1BvcnRhbExpbmtSZXNwb25zZRILCgN1cmwYASABKAkSLgoKZXhwaXJlc19hdBgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXAiRgogU2hhcmVQdWJsaWNJbnF1aXJ5QnlFbWFpbFJlcXVlc3QSDgoGZW1haWxzGAEgAygJEhIKCmlucXVpcnlfaWQYAiABKAkiOgohU2hhcmVQdWJsaWNJbnF1aXJ5QnlFbWFpbFJlc3BvbnNlEhUKDWVtYWlsc19xdWV1ZWQYASABKAUiRgogU2hhcmVQdWJsaWNJbnZvaWNlQnlFbWFpbFJlcXVlc3QSEgoKaW52b2ljZV9pZBgBIAEoCRIOCgZlbWFpbHMYAiADKAkiOgohU2hhcmVQdWJsaWNJbnZvaWNlQnlFbWFpbFJlc3BvbnNlEhUKDWVtYWlsc19xdWV1ZWQYASABKAUi0AEKFENyZWF0ZUJvb2tpbmdSZXF1ZXN0EhcKD29yZ2FuaXphdGlvbl9pZBgBIAEoCRISCgpjb250YWN0X2lkGAIgASgJEjYKCmV2ZW50X3R5cGUYAyABKA4yGS5jb3J0YWRvLnYxLkV2ZW50VHlwZUVudW1CAhgBSACIAQESGwoOZXZlbnRfdHlwZV9rZXkYBSABKAlIAYgBAUINCgtfZXZlbnRfdHlwZUIRCg9fZXZlbnRfdHlwZV9rZXlKBAgEEAVSDmV2ZW50X2xvY2F0aW9uIj0KFUNyZWF0ZUJvb2tpbmdSZXNwb25zZRIkCgdib29raW5nGAEgASgLMhMuY29ydGFkby52MS5Cb29raW5nIi8KGUdldElucXVpcnlPdmVybGFwc1JlcXVlc3QSEgoKaW5xdWlyeV9pZBgBIAEoCSKHAQoaR2V0SW5xdWlyeU92ZXJsYXBzUmVzcG9uc2USNgoVb3ZlcmxhcHBpbmdfaW5xdWlyaWVzGAEgAygLMhcuY29ydGFkby52MS5JbnF1aXJ5TGl0ZRIxChJvdmVybGFwcGluZ19ldmVudHMYAiADKAsyFS5jb3J0YWRvLnYxLkV2ZW50TGl0ZSL4AwoZQ3JlYXRlSW5xdWlyeUV2ZW50UmVxdWVzdBISCgppbnF1aXJ5X2lkGAEgASgJEjMKCmV2ZW50X2RhdGUYAiABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wSACIAQESGQoMZXZlbnRfbGVuZ3RoGAMgASgBSAGIAQESGQoMZXZlbnRfZ3Vlc3RzGAQgASgFSAKIAQESGwoOZXZlbnRfdGltZXpvbmUYBSABKAlIA4gBARI2CgpldmVudF90eXBlGAYgASgOMhkuY29ydGFkby52MS5FdmVudFR5cGVFbnVtQgIYAUgEiAEBEhsKDmV2ZW50X3R5cGVfa2V5GAogASgJSAWIAQESGwoOZXZlbnRfbG9jYXRpb24YByABKAlIBogBARIaCg1iYXJpc3RhX2NvdW50GAggASgFSAeIAQESFwoKY2FydF9jb3VudBgJIAEoBUgIiAEBQg0KC19ldmVudF9kYXRlQg8KDV9ldmVudF9sZW5ndGhCDwoNX2V2ZW50X2d1ZXN0c0IRCg9fZXZlbnRfdGltZXpvbmVCDQoLX2V2ZW50X3R5cGVCEQoPX2V2ZW50X3R5cGVfa2V5QhEKD19ldmVudF9sb2NhdGlvbkIQCg5fYmFyaXN0YV9jb3VudEINCgtfY2FydF9jb3VudCJNChpDcmVhdGVJbnF1aXJ5RXZlbnRSZXNwb25zZRIvCg1pbnF1aXJ5X2V2ZW50GAEgASgLMhguY29ydGFkby52MS5JbnF1aXJ5RXZlbnQioQQKGVVwZGF0ZUlucXVpcnlFdmVudFJlcXVlc3QSCgoCaWQYASABKAkSMwoKZXZlbnRfZGF0ZRgCIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXBIAIgBARIZCgxldmVudF9sZW5ndGgYAyABKAFIAYgBARIZCgxldmVudF9ndWVzdHMYBCABKAVIAogBARIbCg5ldmVudF90aW1lem9uZRgFIAEoCUgDiAEBEjYKCmV2ZW50X3R5cGUYBiABKA4yGS5jb3J0YWRvLnYxLkV2ZW50VHlwZUVudW1CAhgBSASIAQESGwoOZXZlbnRfbG9jYXRpb24YByABKAlIBYgBARIvCgt1cGRhdGVfbWFzaxgIIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5GaWVsZE1hc2sSGgoNYmFyaXN0YV9jb3VudBgJIAEoBUgGiAEBEhcKCmNhcnRfY291bnQYCiABKAVIB4gBARIbCg5ldmVudF90eXBlX2tleRgLIAEoCUgIiAEBQg0KC19ldmVudF9kYXRlQg8KDV9ldmVudF9sZW5ndGhCDwoNX2V2ZW50X2d1ZXN0c0IRCg9fZXZlbnRfdGltZXpvbmVCDQoLX2V2ZW50X3R5cGVCEQoPX2V2ZW50X2xvY2F0aW9uQhAKDl9iYXJpc3RhX2NvdW50Qg0KC19jYXJ0X2NvdW50QhEKD19ldmVudF90eXBlX2tleSJNChpVcGRhdGVJbnF1aXJ5RXZlbnRSZXNwb25zZRIvCg1pbnF1aXJ5X2V2ZW50GAEgASgLMhguY29ydGFkby52MS5JbnF1aXJ5RXZlbnQiJwoZRGVsZXRlSW5xdWlyeUV2ZW50UmVxdWVzdBIKCgJpZBgBIAEoCSItChpEZWxldGVJbnF1aXJ5RXZlbnRSZXNwb25zZRIPCgdtZXNzYWdlGAEgASgJIi4KGExpc3RJbnF1aXJ5RXZlbnRzUmVxdWVzdBISCgppbnF1aXJ5X2lkGAEgASgJIk0KGUxpc3RJbnF1aXJ5RXZlbnRzUmVzcG9uc2USMAoOaW5xdWlyeV9ldmVudHMYASADKAsyGC5jb3J0YWRvLnYxLklucXVpcnlFdmVudCIhChNBcmNoaXZlRXZlbnRSZXF1ZXN0EgoKAmlkGAEgASgJIicKFEFyY2hpdmVFdmVudFJlc3BvbnNlEg8KB21lc3NhZ2UYASABKAkiIwoVVW5hcmNoaXZlRXZlbnRSZXF1ZXN0EgoKAmlkGAEgASgJIikKFlVuYXJjaGl2ZUV2ZW50UmVzcG9uc2USDwoHbWVzc2FnZRgBIAEoCSI7ChVBcmNoaXZlSW5xdWlyeVJlcXVlc3QSCgoCaWQYASABKAkSFgoOY2FzY2FkZV9ldmVudHMYAiABKAgiKQoWQXJjaGl2ZUlucXVpcnlSZXNwb25zZRIPCgdtZXNzYWdlGAEgASgJIiUKF1VuYXJjaGl2ZUlucXVpcnlSZXF1ZXN0EgoKAmlkGAEgASgJIisKGFVuYXJjaGl2ZUlucXVpcnlSZXNwb25zZRIPCgdtZXNzYWdlGAEgASgJQiZaJGh1Yi1iYWNrZW5kL2dlbi9jb3J0YWRvL3YxO2NvcnRhZG92MWIGcHJvdG8z", [file_cortado_v1_contacts, file_cortado_v1_emails, file_cortado_v1_invoices, file_cortado_v1_organizations, file_cortado_v1_questionnaires, file_cortado_v1_settings, file_cortado_v1_users, file_google_protobuf_field_mask, file_google_protobuf_timestamp]);

/**
 * Inquiry represents an inquiry/lead in the system
 *
 * @generated from message cortado.v1.Inquiry
 */
export type Inquiry = Message<"cortado.v1.Inquiry"> & {
  /**
   * Unique identifier for the inquiry
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the inquiry belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Contact ID associated with the inquiry
   *
   * @generated from field: string contact_id = 3;
   */
  contactId: string;

  /**
   * Stage of the inquiry
   *
   * @generated from field: cortado.v1.InquiryStageEnum stage = 4;
   */
  stage: InquiryStageEnum;

  /**
   * Deprecated: legacy enum retained for deployed clients.
   *
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 5 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * Organization-scoped immutable event type key.
   *
   * @generated from field: optional string event_type_key = 6;
   */
  eventTypeKey?: string;

  /**
   * Number of days for the event (optional)
   *
   * @generated from field: optional int32 event_days = 7;
   */
  eventDays?: number;

  /**
   * Location of the event (optional)
   *
   * @generated from field: optional string event_location = 9;
   */
  eventLocation?: string;

  /**
   * Referrer source (optional)
   *
   * @generated from field: optional string referrer = 12;
   */
  referrer?: string;

  /**
   * Inquiry events (multiple events per inquiry)
   *
   * @generated from field: repeated cortado.v1.InquiryEvent events = 80;
   */
  events: InquiryEvent[];

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: string created_by = 14;
   */
  createdBy: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 15;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by user ID
   *
   * @generated from field: string updated_by = 16;
   */
  updatedBy: string;

  /**
   * Time the inquiry was archived, if archived
   *
   * @generated from field: optional google.protobuf.Timestamp archived_at = 50;
   */
  archivedAt?: Timestamp;

  /**
   * User ID of the user who archived this inquiry
   *
   * @generated from field: optional string archived_by = 51;
   */
  archivedBy?: string;

  /**
   * Embedded full objects (ID references kept above)
   *
   * @generated from field: optional cortado.v1.Contact contact = 20;
   */
  contact?: Contact;

  /**
   * @generated from field: optional cortado.v1.User created_by_user = 21;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 22;
   */
  updatedByUser?: User;

  /**
   * Nested collections - ID references only (use separate queries to fetch full objects)
   *
   * @generated from field: repeated string note_ids = 30;
   */
  noteIds: string[];

  /**
   * @generated from field: repeated string task_ids = 31;
   */
  taskIds: string[];

  /**
   * ID references only (use ListQuotes to fetch)
   *
   * @generated from field: repeated string quote_ids = 32;
   */
  quoteIds: string[];

  /**
   * ID references only (use ListItems to fetch)
   *
   * @generated from field: repeated string item_ids = 60;
   */
  itemIds: string[];

  /**
   * Pre-calculated aggregations
   * Quote aggregations only - use ListQuotes with inquiry_id filter to fetch quotes
   *
   * @generated from field: optional float quote_total = 40;
   */
  quoteTotal?: number;

  /**
   * @generated from field: optional float quote_subtotal = 41;
   */
  quoteSubtotal?: number;

  /**
   * @generated from field: optional float quote_tax = 42;
   */
  quoteTax?: number;

  /**
   * @generated from field: int32 notes_count = 43;
   */
  notesCount: number;

  /**
   * @generated from field: int32 tasks_count = 44;
   */
  tasksCount: number;

  /**
   * @generated from field: int32 quotes_count = 45;
   */
  quotesCount: number;

  /**
   * @generated from field: int32 items_count = 46;
   */
  itemsCount: number;

  /**
   * Booking ID if inquiry has been converted to booking (via quote acceptance)
   *
   * @generated from field: optional string booking_id = 70;
   */
  bookingId?: string;

  /**
   * Event IDs from the booking (for navigation to event detail page)
   *
   * @generated from field: repeated string event_ids = 71;
   */
  eventIds: string[];

  /**
   * Tags for quick status identification
   *
   * @generated from field: repeated cortado.v1.InquiryTagEnum tags = 72;
   */
  tags: InquiryTagEnum[];

  /**
   * Attribution source data (JSONB in DB, serialized as JSON string in proto)
   *
   * @generated from field: optional string source = 81;
   */
  source?: string;

  /**
   * Reject reason when inquiry is moved to rejected stage
   *
   * @generated from field: optional cortado.v1.InquiryRejectReasonEnum reject_reason = 82;
   */
  rejectReason?: InquiryRejectReasonEnum;

  /**
   * Free-text notes about the rejection
   *
   * @generated from field: optional string reject_notes = 83;
   */
  rejectNotes?: string;

  /**
   * User ID the lead is assigned to (optional)
   *
   * @generated from field: optional string assigned_to = 84;
   */
  assignedTo?: string;

  /**
   * Full user object for the assigned_to user
   *
   * @generated from field: optional cortado.v1.User assigned_to_user = 85;
   */
  assignedToUser?: User;

  /**
   * Whether a questionnaire should be attached to the booking created from
   * this lead. Defaults to true; quotes inherit this value at creation.
   *
   * @generated from field: bool requires_questionnaire = 86;
   */
  requiresQuestionnaire: boolean;

  /**
   * @generated from field: optional string job_id = 87;
   */
  jobId?: string;

  /**
   * Mail on the lead (CPRO-790): when the customer last wrote, when we last
   * wrote, and which of the two came last. Unset until the lead has mail.
   * Mail linked to the lead's quotes, booking and invoices counts too, and
   * automatic replies never do.
   *
   * @generated from field: optional google.protobuf.Timestamp last_inbound_at = 88;
   */
  lastInboundAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_outbound_at = 89;
   */
  lastOutboundAt?: Timestamp;

  /**
   * @generated from field: optional cortado.v1.EmailMessageDirection last_message_direction = 90;
   */
  lastMessageDirection?: EmailMessageDirection;
};

/**
 * Describes the message cortado.v1.Inquiry.
 * Use `create(InquirySchema)` to create a new message.
 */
export const InquirySchema: GenMessage<Inquiry> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 0);

/**
 * InquiryLite is a lightweight inquiry representation for list views
 * Contains only essential display fields to minimize payload size
 *
 * @generated from message cortado.v1.InquiryLite
 */
export type InquiryLite = Message<"cortado.v1.InquiryLite"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: cortado.v1.InquiryStageEnum stage = 3;
   */
  stage: InquiryStageEnum;

  /**
   * Event details
   *
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 13 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional string event_type_key = 14;
   */
  eventTypeKey?: string;

  /**
   * Contact summary (denormalized for performance)
   *
   * @generated from field: string contact_id = 20;
   */
  contactId: string;

  /**
   * @generated from field: string contact_first_name = 21;
   */
  contactFirstName: string;

  /**
   * @generated from field: string contact_last_name = 22;
   */
  contactLastName: string;

  /**
   * Quote summary
   *
   * @generated from field: optional float quote_total = 30;
   */
  quoteTotal?: number;

  /**
   * Total of the ACCEPTED quote revision(s) on this lead, in cents.
   *
   * Unlike quote_total (a float across every quote's *current* revision,
   * regardless of acceptance), this is integer cents specifically so consumers
   * can sum it without float drift -- it is the lead's booked revenue.
   *
   * Absent (not 0) when the lead has no accepted quote, so "no accepted quote"
   * stays distinguishable from "accepted for $0".
   *
   * @generated from field: optional int64 accepted_quote_total_cents = 31;
   */
  acceptedQuoteTotalCents?: bigint;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 40;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 41;
   */
  updatedAt?: Timestamp;

  /**
   * Booking ID if inquiry has been converted to booking
   *
   * @generated from field: optional string booking_id = 50;
   */
  bookingId?: string;

  /**
   * Time the inquiry was archived, if archived
   *
   * @generated from field: optional google.protobuf.Timestamp archived_at = 51;
   */
  archivedAt?: Timestamp;

  /**
   * User ID of the user who archived this inquiry
   *
   * @generated from field: optional string archived_by = 52;
   */
  archivedBy?: string;

  /**
   * First event date (for display in list views)
   *
   * @generated from field: optional google.protobuf.Timestamp first_event_date = 60;
   */
  firstEventDate?: Timestamp;

  /**
   * Total event count
   *
   * @generated from field: int32 events_count = 61;
   */
  eventsCount: number;

  /**
   * Last event date (for date range display)
   *
   * @generated from field: optional google.protobuf.Timestamp last_event_date = 62;
   */
  lastEventDate?: Timestamp;

  /**
   * Total guest count across all events
   *
   * @generated from field: int32 total_guest_count = 63;
   */
  totalGuestCount: number;

  /**
   * IANA timezone of the chronologically-first inquiry_event. Used by list/kanban
   * surfaces to render `first_event_date` in the event's own timezone instead of
   * the viewer's local zone. Empty/null when the first event has no timezone.
   *
   * @generated from field: optional string first_event_timezone = 66;
   */
  firstEventTimezone?: string;

  /**
   * Tags for quick status identification
   *
   * @generated from field: repeated cortado.v1.InquiryTagEnum tags = 64;
   */
  tags: InquiryTagEnum[];

  /**
   * Inquiry events (for calendar multi-day display)
   *
   * @generated from field: repeated cortado.v1.InquiryEvent inquiry_events = 65;
   */
  inquiryEvents: InquiryEvent[];

  /**
   * Company name associated with the contact (optional, first alphabetically)
   *
   * @generated from field: optional string contact_company_name = 70;
   */
  contactCompanyName?: string;

  /**
   * Attribution source data (JSONB in DB, serialized as JSON string in proto)
   *
   * @generated from field: optional string source = 71;
   */
  source?: string;

  /**
   * Assignee summary (denormalized for performance)
   *
   * @generated from field: optional string assigned_to = 72;
   */
  assignedTo?: string;

  /**
   * @generated from field: optional string assigned_to_first_name = 73;
   */
  assignedToFirstName?: string;

  /**
   * @generated from field: optional string assigned_to_last_name = 74;
   */
  assignedToLastName?: string;

  /**
   * @generated from field: optional string job_id = 75;
   */
  jobId?: string;

  /**
   * Mail on the lead (CPRO-790): when the customer last wrote, when we last
   * wrote, and which of the two came last. Unset until the lead has mail.
   * Mail linked to the lead's quotes, booking and invoices counts too, and
   * automatic replies never do.
   *
   * @generated from field: optional google.protobuf.Timestamp last_inbound_at = 76;
   */
  lastInboundAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_outbound_at = 77;
   */
  lastOutboundAt?: Timestamp;

  /**
   * @generated from field: optional cortado.v1.EmailMessageDirection last_message_direction = 78;
   */
  lastMessageDirection?: EmailMessageDirection;
};

/**
 * Describes the message cortado.v1.InquiryLite.
 * Use `create(InquiryLiteSchema)` to create a new message.
 */
export const InquiryLiteSchema: GenMessage<InquiryLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 1);

/**
 * Booking represents a confirmed booking in the system
 *
 * @generated from message cortado.v1.Booking
 */
export type Booking = Message<"cortado.v1.Booking"> & {
  /**
   * Unique identifier for the booking
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the booking belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Inquiry ID that led to this booking (optional - null for direct bookings)
   *
   * @generated from field: optional string inquiry_id = 3;
   */
  inquiryId?: string;

  /**
   * Contact ID associated with the booking
   *
   * @generated from field: string contact_id = 4;
   */
  contactId: string;

  /**
   * Stage of the booking
   *
   * @generated from field: cortado.v1.BookingStageEnum stage = 5;
   */
  stage: BookingStageEnum;

  /**
   * Type of event (optional)
   *
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 6 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional string event_type_key = 14;
   */
  eventTypeKey?: string;

  /**
   * Snapshot of the event-type questionnaire, including answers.
   *
   * @generated from field: optional cortado.v1.Questionnaire questionnaire = 15;
   */
  questionnaire?: Questionnaire;

  /**
   * State where event is located (optional)
   *
   * @generated from field: optional string event_state = 8;
   */
  eventState?: string;

  /**
   * County where event is located (optional)
   *
   * @generated from field: optional string event_county = 9;
   */
  eventCounty?: string;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 10;
   */
  createdAt?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: string created_by = 11;
   */
  createdBy: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 12;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by user ID
   *
   * @generated from field: string updated_by = 13;
   */
  updatedBy: string;

  /**
   * Embedded full objects (ID references kept above)
   *
   * @generated from field: optional cortado.v1.User created_by_user = 21;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 22;
   */
  updatedByUser?: User;

  /**
   * Nested collections - ID references only (use separate queries to fetch full objects)
   *
   * ID references only (use ListNotes to fetch)
   *
   * @generated from field: repeated string note_ids = 30;
   */
  noteIds: string[];

  /**
   * ID references only (use ListTasks to fetch)
   *
   * @generated from field: repeated string task_ids = 31;
   */
  taskIds: string[];

  /**
   * ID references only (use ListEvents to fetch)
   *
   * @generated from field: repeated string event_ids = 32;
   */
  eventIds: string[];

  /**
   * ID references only (use ListInvoices to fetch)
   *
   * @generated from field: repeated string invoice_ids = 33;
   */
  invoiceIds: string[];

  /**
   * Pre-calculated aggregations
   *
   * @generated from field: float total_invoice_amount = 40;
   */
  totalInvoiceAmount: number;

  /**
   * @generated from field: float total_paid = 41;
   */
  totalPaid: number;

  /**
   * @generated from field: float total_due = 42;
   */
  totalDue: number;

  /**
   * @generated from field: int32 events_count = 43;
   */
  eventsCount: number;

  /**
   * @generated from field: int32 invoices_count = 44;
   */
  invoicesCount: number;

  /**
   * @generated from field: int32 notes_count = 45;
   */
  notesCount: number;

  /**
   * @generated from field: int32 tasks_count = 46;
   */
  tasksCount: number;

  /**
   * @generated from field: optional string job_id = 47;
   */
  jobId?: string;

  /**
   * Mail on the booking and its lead (CPRO-790), the same values as the
   * lead's. Unset until there is mail.
   *
   * @generated from field: optional google.protobuf.Timestamp last_inbound_at = 48;
   */
  lastInboundAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_outbound_at = 49;
   */
  lastOutboundAt?: Timestamp;

  /**
   * @generated from field: optional cortado.v1.EmailMessageDirection last_message_direction = 50;
   */
  lastMessageDirection?: EmailMessageDirection;

  /**
   * When the questionnaire first reached the customer (portal acceptance or
   * an invoice email linking the booking page). Unset until then, and for a
   * booking without questions.
   *
   * @generated from field: optional google.protobuf.Timestamp questionnaire_sent_at = 51;
   */
  questionnaireSentAt?: Timestamp;

  /**
   * When the customer last submitted answers. Unset until they do.
   *
   * @generated from field: optional google.protobuf.Timestamp questionnaire_returned_at = 52;
   */
  questionnaireReturnedAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.Booking.
 * Use `create(BookingSchema)` to create a new message.
 */
export const BookingSchema: GenMessage<Booking> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 2);

/**
 * Event represents an event in the system
 *
 * @generated from message cortado.v1.Event
 */
export type Event = Message<"cortado.v1.Event"> & {
  /**
   * Unique identifier for the event
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the event belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Contact ID associated with the event
   *
   * @generated from field: string contact_id = 3;
   */
  contactId: string;

  /**
   * Booking ID associated with the event
   *
   * @generated from field: string booking_id = 4;
   */
  bookingId: string;

  /**
   * Stage of the event
   *
   * @generated from field: cortado.v1.EventStageEnum stage = 5;
   */
  stage: EventStageEnum;

  /**
   * Date of the event (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 6;
   */
  eventDate?: Timestamp;

  /**
   * Length of the event in hours (optional)
   *
   * @generated from field: optional double event_length = 7;
   */
  eventLength?: number;

  /**
   * Number of guests (optional)
   *
   * @generated from field: optional int32 event_guests = 8;
   */
  eventGuests?: number;

  /**
   * Timezone of the event (optional)
   *
   * @generated from field: optional string event_timezone = 9;
   */
  eventTimezone?: string;

  /**
   * Calendar ID from Google Calendar (optional)
   *
   * @generated from field: optional string calendar_id = 10;
   */
  calendarId?: string;

  /**
   * Type of event (optional)
   *
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 15 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional string event_type_key = 19;
   */
  eventTypeKey?: string;

  /**
   * Location of the event (optional)
   *
   * @generated from field: optional string event_location = 16;
   */
  eventLocation?: string;

  /**
   * Number of baristas needed (optional) - for resource planning
   *
   * @generated from field: optional int32 barista_count = 17;
   */
  baristaCount?: number;

  /**
   * Number of carts needed (optional) - for resource planning
   *
   * @generated from field: optional int32 cart_count = 18;
   */
  cartCount?: number;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 11;
   */
  createdAt?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: string created_by = 12;
   */
  createdBy: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 13;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by user ID
   *
   * @generated from field: string updated_by = 14;
   */
  updatedBy: string;

  /**
   * Time the event was archived, if archived
   *
   * @generated from field: optional google.protobuf.Timestamp archived_at = 50;
   */
  archivedAt?: Timestamp;

  /**
   * User ID of the user who archived this event
   *
   * @generated from field: optional string archived_by = 51;
   */
  archivedBy?: string;

  /**
   * Embedded full objects (ID references kept above)
   *
   * @generated from field: optional cortado.v1.Contact contact = 20;
   */
  contact?: Contact;

  /**
   * @generated from field: optional cortado.v1.User created_by_user = 21;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 22;
   */
  updatedByUser?: User;

  /**
   * Nested collections - ID references only
   *
   * ID references only (use GetUserScheduling to fetch)
   *
   * @generated from field: repeated string user_scheduling_ids = 30;
   */
  userSchedulingIds: string[];

  /**
   * ID references only (use ListNotes to fetch)
   *
   * @generated from field: repeated string note_ids = 31;
   */
  noteIds: string[];

  /**
   * ID references only (use ListTasks to fetch)
   *
   * @generated from field: repeated string task_ids = 32;
   */
  taskIds: string[];

  /**
   * Pre-calculated aggregations
   *
   * @generated from field: int32 scheduled_users_count = 40;
   */
  scheduledUsersCount: number;

  /**
   * Google Calendar sync state (server-managed, read-only). Unset until the
   * first sync attempt for this event completes.
   * Values: "synced" | "failed" | "skipped" | "skipped_policy" | "deleted".
   *
   * @generated from field: optional string calendar_sync_status = 41;
   */
  calendarSyncStatus?: string;

  /**
   * Timestamp of the last successful calendar sync.
   *
   * @generated from field: optional google.protobuf.Timestamp calendar_synced_at = 42;
   */
  calendarSyncedAt?: Timestamp;

  /**
   * Human-readable reason for the last failed or skipped sync.
   *
   * @generated from field: optional string calendar_sync_error = 43;
   */
  calendarSyncError?: string;

  /**
   * Per-event override of the Google Calendar description template source.
   * Unset inherits the organization's CalendarSyncSettings.description_template
   * (which itself falls back to the legacy generated description when empty).
   *
   * @generated from field: optional string calendar_description_override = 44;
   */
  calendarDescriptionOverride?: string;

  /**
   * @generated from field: optional string job_id = 45;
   */
  jobId?: string;
};

/**
 * Describes the message cortado.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 3);

/**
 * EventLite is a lightweight event representation for list views
 * Contains only essential display fields to minimize payload size
 *
 * @generated from message cortado.v1.EventLite
 */
export type EventLite = Message<"cortado.v1.EventLite"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * @generated from field: string booking_id = 3;
   */
  bookingId: string;

  /**
   * @generated from field: cortado.v1.EventStageEnum stage = 4;
   */
  stage: EventStageEnum;

  /**
   * Event details
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 10;
   */
  eventDate?: Timestamp;

  /**
   * @generated from field: optional double event_length = 11;
   */
  eventLength?: number;

  /**
   * @generated from field: optional int32 event_guests = 12;
   */
  eventGuests?: number;

  /**
   * @generated from field: optional string event_timezone = 13;
   */
  eventTimezone?: string;

  /**
   * Denormalized for filtering inquiries with events
   *
   * @generated from field: optional string inquiry_id = 14;
   */
  inquiryId?: string;

  /**
   * Type of event (optional)
   *
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 15 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional string event_type_key = 19;
   */
  eventTypeKey?: string;

  /**
   * Location of the event (optional)
   *
   * @generated from field: optional string event_location = 16;
   */
  eventLocation?: string;

  /**
   * Number of baristas needed (optional) - for resource planning
   *
   * @generated from field: optional int32 barista_count = 17;
   */
  baristaCount?: number;

  /**
   * Number of carts needed (optional) - for resource planning
   *
   * @generated from field: optional int32 cart_count = 18;
   */
  cartCount?: number;

  /**
   * Contact summary (denormalized for performance)
   *
   * @generated from field: string contact_id = 20;
   */
  contactId: string;

  /**
   * @generated from field: string contact_first_name = 21;
   */
  contactFirstName: string;

  /**
   * @generated from field: string contact_last_name = 22;
   */
  contactLastName: string;

  /**
   * Time the event was archived, if archived
   *
   * @generated from field: optional google.protobuf.Timestamp archived_at = 50;
   */
  archivedAt?: Timestamp;

  /**
   * User ID of the user who archived this event
   *
   * @generated from field: optional string archived_by = 51;
   */
  archivedBy?: string;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp created_at = 30;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 31;
   */
  updatedAt?: Timestamp;

  /**
   * @generated from field: optional string job_id = 32;
   */
  jobId?: string;
};

/**
 * Describes the message cortado.v1.EventLite.
 * Use `create(EventLiteSchema)` to create a new message.
 */
export const EventLiteSchema: GenMessage<EventLite> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 4);

/**
 * InquiryEvent represents an event associated with an inquiry
 * Unlike Event (which is for confirmed bookings), InquiryEvent captures
 * potential event dates/times during the lead stage before booking conversion
 * Fields are aligned with Event for seamless inquiry-to-booking conversion
 *
 * @generated from message cortado.v1.InquiryEvent
 */
export type InquiryEvent = Message<"cortado.v1.InquiryEvent"> & {
  /**
   * Unique identifier for the inquiry event
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Organization ID the inquiry event belongs to
   *
   * @generated from field: string organization_id = 2;
   */
  organizationId: string;

  /**
   * Inquiry ID this event belongs to
   *
   * @generated from field: string inquiry_id = 3;
   */
  inquiryId: string;

  /**
   * Date of the event (optional - may not be set initially)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 4;
   */
  eventDate?: Timestamp;

  /**
   * Length of the event in hours (optional) - aligned with Event.event_length
   *
   * @generated from field: optional double event_length = 5;
   */
  eventLength?: number;

  /**
   * Number of guests (optional) - aligned with Event.event_guests
   *
   * @generated from field: optional int32 event_guests = 6;
   */
  eventGuests?: number;

  /**
   * Timezone of the event (optional) - aligned with Event.event_timezone
   *
   * @generated from field: optional string event_timezone = 7;
   */
  eventTimezone?: string;

  /**
   * Type of event (optional) - aligned with Event.event_type_key
   *
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 8 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional string event_type_key = 12;
   */
  eventTypeKey?: string;

  /**
   * Location of the event (optional) - aligned with Event.event_location
   *
   * @generated from field: optional string event_location = 9;
   */
  eventLocation?: string;

  /**
   * Number of baristas needed (optional) - for resource planning
   *
   * @generated from field: optional int32 barista_count = 10;
   */
  baristaCount?: number;

  /**
   * Number of carts needed (optional) - for resource planning
   *
   * @generated from field: optional int32 cart_count = 11;
   */
  cartCount?: number;
};

/**
 * Describes the message cortado.v1.InquiryEvent.
 * Use `create(InquiryEventSchema)` to create a new message.
 */
export const InquiryEventSchema: GenMessage<InquiryEvent> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 5);

/**
 * UserScheduling represents a user's scheduling for an event
 *
 * @generated from message cortado.v1.UserScheduling
 */
export type UserScheduling = Message<"cortado.v1.UserScheduling"> & {
  /**
   * Unique identifier for the user scheduling
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Event ID
   *
   * @generated from field: string event_id = 2;
   */
  eventId: string;

  /**
   * User ID being scheduled
   *
   * @generated from field: string user_id = 3;
   */
  userId: string;

  /**
   * When the user is scheduled
   *
   * @generated from field: google.protobuf.Timestamp scheduled_at = 4;
   */
  scheduledAt?: Timestamp;

  /**
   * Duration of the scheduling in hours
   *
   * @generated from field: double duration = 5;
   */
  duration: number;

  /**
   * Status of the scheduling
   *
   * @generated from field: cortado.v1.UserSchedulingStatusEnum status = 6;
   */
  status: UserSchedulingStatusEnum;

  /**
   * LEAD or BARISTA. At most one LEAD per event.
   *
   * @generated from field: cortado.v1.UserSchedulingRoleEnum role = 12;
   */
  role: UserSchedulingRoleEnum;

  /**
   * Created at timestamp
   *
   * @generated from field: google.protobuf.Timestamp created_at = 7;
   */
  createdAt?: Timestamp;

  /**
   * Created by user ID
   *
   * @generated from field: string created_by = 8;
   */
  createdBy: string;

  /**
   * Updated at timestamp
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 9;
   */
  updatedAt?: Timestamp;

  /**
   * Updated by user ID
   *
   * @generated from field: string updated_by = 10;
   */
  updatedBy: string;

  /**
   * Embedded full objects (user from user_id field)
   *
   * @generated from field: optional cortado.v1.User user = 11;
   */
  user?: User;

  /**
   * @generated from field: optional cortado.v1.User created_by_user = 20;
   */
  createdByUser?: User;

  /**
   * @generated from field: optional cortado.v1.User updated_by_user = 21;
   */
  updatedByUser?: User;

  /**
   * @generated from field: optional cortado.v1.Event event = 22;
   */
  event?: Event;
};

/**
 * Describes the message cortado.v1.UserScheduling.
 * Use `create(UserSchedulingSchema)` to create a new message.
 */
export const UserSchedulingSchema: GenMessage<UserScheduling> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 6);

/**
 * PublicInquiry is a customer-facing representation of an inquiry
 * Contains only public information suitable for external viewing
 * Excludes internal data like notes, tasks, user IDs, and sensitive contact info
 *
 * @generated from message cortado.v1.PublicInquiry
 */
export type PublicInquiry = Message<"cortado.v1.PublicInquiry"> & {
  /**
   * Core identification
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: cortado.v1.InquiryStageEnum stage = 2;
   */
  stage: InquiryStageEnum;

  /**
   * Event details
   *
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 10 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional string event_type_key = 11;
   */
  eventTypeKey?: string;

  /**
   * @generated from field: optional int32 event_days = 12;
   */
  eventDays?: number;

  /**
   * @generated from field: optional string event_location = 14;
   */
  eventLocation?: string;

  /**
   * Contact information (limited - no email/phone)
   *
   * @generated from field: string contact_first_name = 20;
   */
  contactFirstName: string;

  /**
   * @generated from field: string contact_last_name = 21;
   */
  contactLastName: string;

  /**
   * Line items (catalog items)
   *
   * @generated from field: repeated cortado.v1.PublicItem items = 30;
   */
  items: PublicItem[];

  /**
   * Quotes with line items and totals
   *
   * @generated from field: repeated cortado.v1.PublicQuote quotes = 40;
   */
  quotes: PublicQuote[];

  /**
   * Public organization info
   *
   * @generated from field: cortado.v1.PublicOrganization organization = 50;
   */
  organization?: PublicOrganization;

  /**
   * Timestamps (no user IDs)
   *
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 61;
   */
  updatedAt?: Timestamp;

  /**
   * Inquiry events (multiple events)
   *
   * @generated from field: repeated cortado.v1.InquiryEvent events = 70;
   */
  events: InquiryEvent[];
};

/**
 * Describes the message cortado.v1.PublicInquiry.
 * Use `create(PublicInquirySchema)` to create a new message.
 */
export const PublicInquirySchema: GenMessage<PublicInquiry> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 7);

/**
 * PublicItem is a customer-facing representation of a line item
 *
 * @generated from message cortado.v1.PublicItem
 */
export type PublicItem = Message<"cortado.v1.PublicItem"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: optional string description = 3;
   */
  description?: string;
};

/**
 * Describes the message cortado.v1.PublicItem.
 * Use `create(PublicItemSchema)` to create a new message.
 */
export const PublicItemSchema: GenMessage<PublicItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 8);

/**
 * PublicQuote is a customer-facing representation of a quote
 *
 * @generated from message cortado.v1.PublicQuote
 */
export type PublicQuote = Message<"cortado.v1.PublicQuote"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 quote_number = 2;
   */
  quoteNumber: number;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: optional string description = 4;
   */
  description?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp valid_until = 5;
   */
  validUntil?: Timestamp;

  /**
   * Line items with pricing
   *
   * @generated from field: repeated cortado.v1.QuoteLineItem line_items = 10;
   */
  lineItems: QuoteLineItem[];

  /**
   * Totals
   *
   * @generated from field: int64 subtotal_cents = 20;
   */
  subtotalCents: bigint;

  /**
   * @generated from field: int64 sales_tax_cents = 21;
   */
  salesTaxCents: bigint;

  /**
   * @generated from field: int64 discount_cents = 22;
   */
  discountCents: bigint;

  /**
   * @generated from field: optional int64 enforced_tip_cents = 23;
   */
  enforcedTipCents?: bigint;

  /**
   * Excludes tip
   *
   * @generated from field: int64 total_cents = 24;
   */
  totalCents: bigint;

  /**
   * @generated from field: optional double enforced_tip_percentage = 25;
   */
  enforcedTipPercentage?: number;

  /**
   * total_cents plus enforced_tip_cents: the amount the customer pays at checkout.
   *
   * @generated from field: int64 total_with_tip_cents = 76;
   */
  totalWithTipCents: bigint;

  /**
   * Discount info (if applicable)
   *
   * @generated from field: optional string discount_name = 30;
   */
  discountName?: string;

  /**
   * @generated from field: optional cortado.v1.DiscountTypeEnum discount_type = 31;
   */
  discountType?: DiscountTypeEnum;

  /**
   * @generated from field: optional double discount_value = 32;
   */
  discountValue?: number;

  /**
   * Event details - LEGACY single event fields (for backward compatibility)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 35;
   */
  eventDate?: Timestamp;

  /**
   * @generated from field: optional string event_location = 36;
   */
  eventLocation?: string;

  /**
   * @generated from field: optional int32 guest_count = 37;
   */
  guestCount?: number;

  /**
   * in hours
   *
   * @generated from field: optional double event_duration = 38;
   */
  eventDuration?: number;

  /**
   * Status and timestamps
   *
   * @generated from field: cortado.v1.QuoteStatusEnum status = 40;
   */
  status: QuoteStatusEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp sent_at = 41;
   */
  sentAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp viewed_at = 42;
   */
  viewedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp accepted_at = 43;
   */
  acceptedAt?: Timestamp;

  /**
   * Payment schedules
   *
   * @generated from field: repeated cortado.v1.QuotePaymentSchedule payment_schedules = 50;
   */
  paymentSchedules: QuotePaymentSchedule[];

  /**
   * Timestamps (no user IDs)
   *
   * @generated from field: google.protobuf.Timestamp created_at = 60;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp updated_at = 61;
   */
  updatedAt?: Timestamp;

  /**
   * Booking ID (populated if quote has been accepted)
   *
   * @generated from field: optional string booking_id = 70;
   */
  bookingId?: string;

  /**
   * Quote events - multi-event support
   *
   * @generated from field: repeated cortado.v1.QuoteEvent quote_events = 71;
   */
  quoteEvents: QuoteEvent[];

  /**
   * Add-on offers available to the customer on this quote revision
   *
   * @generated from field: repeated cortado.v1.QuoteAddonOffer addon_offers = 73;
   */
  addonOffers: QuoteAddonOffer[];

  /**
   * Explicit "flag off" vs "no offers configured" signal for the portal
   *
   * @generated from field: bool quote_addons_enabled = 74;
   */
  quoteAddonsEnabled: boolean;

  /**
   * The quote's current_revision_id at the time this response was built.
   * Sent back on AcceptPublicQuoteRequest.revision_id so the backend can
   * reject a stale accept.
   *
   * @generated from field: string revision_id = 75;
   */
  revisionId: string;

  /**
   * @generated from field: cortado.v1.TipAllocationModeEnum tip_allocation_mode = 77;
   */
  tipAllocationMode: TipAllocationModeEnum;
};

/**
 * Describes the message cortado.v1.PublicQuote.
 * Use `create(PublicQuoteSchema)` to create a new message.
 */
export const PublicQuoteSchema: GenMessage<PublicQuote> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 9);

/**
 * PublicOrganization is a customer-facing representation of an organization
 * Contains only public-facing information
 *
 * @generated from message cortado.v1.PublicOrganization
 */
export type PublicOrganization = Message<"cortado.v1.PublicOrganization"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: optional string logo_url = 3;
   */
  logoUrl?: string;

  /**
   * @generated from field: optional string website_url = 4;
   */
  websiteUrl?: string;

  /**
   * @generated from field: optional string contact_email = 5;
   */
  contactEmail?: string;

  /**
   * Agreements (e.g., terms and conditions) for display in portal footer
   *
   * @generated from field: repeated cortado.v1.PublicAgreement agreements = 6;
   */
  agreements: PublicAgreement[];

  /**
   * When true, the portal sends the customer through the booking
   * questionnaire before payment, and checkout refuses while required
   * questions are unanswered.
   *
   * @generated from field: bool require_questionnaire_before_payment = 7;
   */
  requireQuestionnaireBeforePayment: boolean;

  /**
   * Photo gallery shown in the portal footer, in display order.
   *
   * @generated from field: repeated cortado.v1.PublicGalleryImage gallery_images = 8;
   */
  galleryImages: PublicGalleryImage[];
};

/**
 * Describes the message cortado.v1.PublicOrganization.
 * Use `create(PublicOrganizationSchema)` to create a new message.
 */
export const PublicOrganizationSchema: GenMessage<PublicOrganization> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 10);

/**
 * PublicGalleryImage is one organization gallery photo as the portal shows it.
 *
 * @generated from message cortado.v1.PublicGalleryImage
 */
export type PublicGalleryImage = Message<"cortado.v1.PublicGalleryImage"> & {
  /**
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * @generated from field: string alt_text = 2;
   */
  altText: string;

  /**
   * @generated from field: optional int32 width_px = 3;
   */
  widthPx?: number;

  /**
   * @generated from field: optional int32 height_px = 4;
   */
  heightPx?: number;
};

/**
 * Describes the message cortado.v1.PublicGalleryImage.
 * Use `create(PublicGalleryImageSchema)` to create a new message.
 */
export const PublicGalleryImageSchema: GenMessage<PublicGalleryImage> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 11);

/**
 * PublicAgreement is a customer-facing representation of an agreement
 *
 * @generated from message cortado.v1.PublicAgreement
 */
export type PublicAgreement = Message<"cortado.v1.PublicAgreement"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string type = 2;
   */
  type: string;

  /**
   * @generated from field: string name = 3;
   */
  name: string;

  /**
   * @generated from field: repeated cortado.v1.PublicAgreementClause clauses = 4;
   */
  clauses: PublicAgreementClause[];
};

/**
 * Describes the message cortado.v1.PublicAgreement.
 * Use `create(PublicAgreementSchema)` to create a new message.
 */
export const PublicAgreementSchema: GenMessage<PublicAgreement> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 12);

/**
 * PublicAgreementClause is a customer-facing representation of an agreement clause
 *
 * @generated from message cortado.v1.PublicAgreementClause
 */
export type PublicAgreementClause = Message<"cortado.v1.PublicAgreementClause"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string body = 3;
   */
  body: string;

  /**
   * @generated from field: int32 display_order = 4;
   */
  displayOrder: number;
};

/**
 * Describes the message cortado.v1.PublicAgreementClause.
 * Use `create(PublicAgreementClauseSchema)` to create a new message.
 */
export const PublicAgreementClauseSchema: GenMessage<PublicAgreementClause> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 13);

/**
 * PublicContact is a customer-facing representation of a contact
 * Contains only public-facing name information
 *
 * @generated from message cortado.v1.PublicContact
 */
export type PublicContact = Message<"cortado.v1.PublicContact"> & {
  /**
   * @generated from field: string first_name = 1;
   */
  firstName: string;

  /**
   * @generated from field: string last_name = 2;
   */
  lastName: string;
};

/**
 * Describes the message cortado.v1.PublicContact.
 * Use `create(PublicContactSchema)` to create a new message.
 */
export const PublicContactSchema: GenMessage<PublicContact> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 14);

/**
 * PublicBooking is a customer-facing representation of a booking
 * Contains booking details with events and invoices for portal viewing
 *
 * @generated from message cortado.v1.PublicBooking
 */
export type PublicBooking = Message<"cortado.v1.PublicBooking"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string inquiry_id = 2;
   */
  inquiryId: string;

  /**
   * Organization
   *
   * @generated from field: cortado.v1.PublicOrganization organization = 10;
   */
  organization?: PublicOrganization;

  /**
   * Contact (limited info)
   *
   * @generated from field: cortado.v1.PublicContact contact = 11;
   */
  contact?: PublicContact;

  /**
   * Booking details
   *
   * @generated from field: cortado.v1.BookingStageEnum stage = 20;
   */
  stage: BookingStageEnum;

  /**
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 21 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * Org-configured display label for event_type, resolved server-side (reflects
   * renames and still resolves for archived types). Falls back to the raw key
   * if resolution fails; empty if event_type is empty.
   *
   * @generated from field: optional string event_type_label = 23;
   */
  eventTypeLabel?: string;

  /**
   * @generated from field: optional string event_type_key = 24;
   */
  eventTypeKey?: string;

  /**
   * Snapshot of the booking's questionnaire, including any answers the
   * customer has submitted. Copied from the org/event-type templates when the
   * booking is created, or authored directly by staff on the event screen.
   *
   * @generated from field: optional cortado.v1.Questionnaire questionnaire = 25;
   */
  questionnaire?: Questionnaire;

  /**
   * Events (date, time, guests)
   *
   * @generated from field: repeated cortado.v1.PublicEvent events = 30;
   */
  events: PublicEvent[];

  /**
   * Invoice IDs (use GetPublicInvoice to fetch full data)
   *
   * @generated from field: repeated string invoice_ids = 40;
   */
  invoiceIds: string[];
};

/**
 * Describes the message cortado.v1.PublicBooking.
 * Use `create(PublicBookingSchema)` to create a new message.
 */
export const PublicBookingSchema: GenMessage<PublicBooking> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 15);

/**
 * PublicEvent is a customer-facing representation of an event
 * Contains event details for portal viewing
 * Note: barista_count and cart_count are intentionally excluded — internal operational data only
 *
 * @generated from message cortado.v1.PublicEvent
 */
export type PublicEvent = Message<"cortado.v1.PublicEvent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp event_date = 10;
   */
  eventDate?: Timestamp;

  /**
   * @generated from field: optional string event_location = 11;
   */
  eventLocation?: string;

  /**
   * @generated from field: optional double event_length = 12;
   */
  eventLength?: number;

  /**
   * @generated from field: optional int32 event_guests = 13;
   */
  eventGuests?: number;

  /**
   * @generated from field: optional string event_timezone = 14;
   */
  eventTimezone?: string;
};

/**
 * Describes the message cortado.v1.PublicEvent.
 * Use `create(PublicEventSchema)` to create a new message.
 */
export const PublicEventSchema: GenMessage<PublicEvent> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 16);

/**
 * PublicInvoice is a customer-facing representation of an invoice
 * Contains invoice details for portal viewing
 *
 * @generated from message cortado.v1.PublicInvoice
 */
export type PublicInvoice = Message<"cortado.v1.PublicInvoice"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: optional string title = 2;
   */
  title?: string;

  /**
   * Human-facing invoice number (e.g. rendered as "INV-42" / "#42")
   *
   * @generated from field: int32 invoice_number = 3;
   */
  invoiceNumber: number;

  /**
   * @generated from field: optional string description = 10;
   */
  description?: string;

  /**
   * Totals (in cents)
   *
   * @generated from field: int64 subtotal_cents = 20;
   */
  subtotalCents: bigint;

  /**
   * @generated from field: int64 tax_cents = 21;
   */
  taxCents: bigint;

  /**
   * @generated from field: int64 discount_cents = 22;
   */
  discountCents: bigint;

  /**
   * @generated from field: int64 total_cents = 23;
   */
  totalCents: bigint;

  /**
   * @generated from field: int64 amount_paid_cents = 24;
   */
  amountPaidCents: bigint;

  /**
   * @generated from field: int64 balance_due_cents = 25;
   */
  balanceDueCents: bigint;

  /**
   * Discount info (if applicable) - mirrors PublicQuote so the portal can show
   * the rate behind discount_cents, not just the amount.
   *
   * @generated from field: optional string discount_name = 26;
   */
  discountName?: string;

  /**
   * @generated from field: optional cortado.v1.DiscountTypeEnum discount_type = 27;
   */
  discountType?: DiscountTypeEnum;

  /**
   * @generated from field: optional double discount_value = 28;
   */
  discountValue?: number;

  /**
   * Status
   *
   * @generated from field: cortado.v1.PaymentStatusEnum payment_status = 30;
   */
  paymentStatus: PaymentStatusEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp paid_at = 31;
   */
  paidAt?: Timestamp;

  /**
   * Line items
   *
   * @generated from field: repeated cortado.v1.PublicInvoiceLineItem line_items = 40;
   */
  lineItems: PublicInvoiceLineItem[];

  /**
   * Payment schedules (for detailed invoice view)
   *
   * @generated from field: repeated cortado.v1.PublicPaymentSchedule payment_schedules = 50;
   */
  paymentSchedules: PublicPaymentSchedule[];

  /**
   * Organization (for branding in standalone invoice view)
   *
   * @generated from field: optional cortado.v1.PublicOrganization organization = 60;
   */
  organization?: PublicOrganization;

  /**
   * Tip fields
   *
   * @generated from field: int64 tip_cents = 70;
   */
  tipCents: bigint;

  /**
   * @generated from field: optional int64 enforced_tip_cents = 71;
   */
  enforcedTipCents?: bigint;

  /**
   * @generated from field: optional double enforced_tip_percentage = 72;
   */
  enforcedTipPercentage?: number;

  /**
   * @generated from field: bool enforced_tip_enabled = 73;
   */
  enforcedTipEnabled: boolean;

  /**
   * Tip selector configuration for the portal (defaults applied server-side)
   *
   * @generated from field: optional cortado.v1.OrganizationTipSelectorSettings tip_selector_settings = 74;
   */
  tipSelectorSettings?: OrganizationTipSelectorSettings;

  /**
   * Refund tracking
   *
   * Amount refunded as goodwill (reduces effective total)
   *
   * @generated from field: int64 goodwill_refunded_cents = 80;
   */
  goodwillRefundedCents: bigint;

  /**
   * @generated from field: int64 tip_paid_cents = 82;
   */
  tipPaidCents: bigint;

  /**
   * @generated from field: int64 tip_due_cents = 83;
   */
  tipDueCents: bigint;

  /**
   * @generated from field: int32 tip_accounting_version = 84;
   */
  tipAccountingVersion: number;

  /**
   * @generated from field: cortado.v1.TipAllocationModeEnum tip_allocation_mode = 85;
   */
  tipAllocationMode: TipAllocationModeEnum;
};

/**
 * Describes the message cortado.v1.PublicInvoice.
 * Use `create(PublicInvoiceSchema)` to create a new message.
 */
export const PublicInvoiceSchema: GenMessage<PublicInvoice> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 17);

/**
 * PublicInvoiceLineItem is a customer-facing representation of an invoice line item
 *
 * @generated from message cortado.v1.PublicInvoiceLineItem
 */
export type PublicInvoiceLineItem = Message<"cortado.v1.PublicInvoiceLineItem"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: optional string description = 2;
   */
  description?: string;

  /**
   * @generated from field: double quantity = 3;
   */
  quantity: number;

  /**
   * @generated from field: int64 unit_price_cents = 4;
   */
  unitPriceCents: bigint;

  /**
   * @generated from field: int64 line_total_cents = 5;
   */
  lineTotalCents: bigint;

  /**
   * @generated from field: string unit = 6;
   */
  unit: string;

  /**
   * Per-line-item tax fields
   *
   * @generated from field: bool is_taxable = 7;
   */
  isTaxable: boolean;

  /**
   * @generated from field: optional string sales_tax_rate_name = 8;
   */
  salesTaxRateName?: string;

  /**
   * @generated from field: optional double sales_tax_rate = 9;
   */
  salesTaxRate?: number;

  /**
   * @generated from field: int64 sales_tax_cents = 10;
   */
  salesTaxCents: bigint;

  /**
   * Images of the source catalog item, cover first.
   *
   * @generated from field: repeated cortado.v1.LineItemImage images = 11;
   */
  images: LineItemImage[];
};

/**
 * Describes the message cortado.v1.PublicInvoiceLineItem.
 * Use `create(PublicInvoiceLineItemSchema)` to create a new message.
 */
export const PublicInvoiceLineItemSchema: GenMessage<PublicInvoiceLineItem> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 18);

/**
 * PublicPaymentSchedule is a customer-facing representation of a payment schedule item
 * Used in the portal to show payment breakdown and enable individual payments
 *
 * @generated from message cortado.v1.PublicPaymentSchedule
 */
export type PublicPaymentSchedule = Message<"cortado.v1.PublicPaymentSchedule"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int32 sequence_number = 2;
   */
  sequenceNumber: number;

  /**
   * @generated from field: string description = 3;
   */
  description: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp due_date = 4;
   */
  dueDate?: Timestamp;

  /**
   * @generated from field: int64 amount_cents = 5;
   */
  amountCents: bigint;

  /**
   * @generated from field: int64 amount_paid_cents = 6;
   */
  amountPaidCents: bigint;

  /**
   * @generated from field: cortado.v1.PaymentScheduleStatusEnum status = 7;
   */
  status: PaymentScheduleStatusEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp paid_at = 8;
   */
  paidAt?: Timestamp;

  /**
   * Indicates if a Stripe PaymentIntent exists (not the secret)
   *
   * @generated from field: bool has_payment_intent = 9;
   */
  hasPaymentIntent: boolean;

  /**
   * @generated from field: bool is_overdue = 10;
   */
  isOverdue: boolean;

  /**
   * Highest-sequence schedule eligible for tip; under PRO_RATA other schedules may also carry tip
   *
   * @generated from field: bool is_last_unpaid = 11;
   */
  isLastUnpaid: boolean;

  /**
   * amount_cents plus tip this schedule's checkout will collect; set on every such schedule
   *
   * @generated from field: optional int64 amount_with_tip_cents = 12;
   */
  amountWithTipCents?: bigint;

  /**
   * ACH microdeposit verification: Stripe hosted URL for bank account verification
   * Set when payment requires verification before processing
   *
   * @generated from field: optional string hosted_verification_url = 13;
   */
  hostedVerificationUrl?: string;

  /**
   * True when the most recent payment attempt for this schedule failed
   * (e.g. an ACH charge that failed days after initiation). Lets the portal
   * show "previous payment attempt failed" context when the pay button re-arms.
   *
   * @generated from field: bool last_payment_failed = 14;
   */
  lastPaymentFailed: boolean;

  /**
   * Payment history for this schedule (only succeeded payments)
   *
   * @generated from field: repeated cortado.v1.PublicPaymentIntent payments = 20;
   */
  payments: PublicPaymentIntent[];

  /**
   * Refund tracking
   *
   * Goodwill refunds applied to this schedule
   *
   * @generated from field: int64 goodwill_refunded_cents = 30;
   */
  goodwillRefundedCents: bigint;

  /**
   * @generated from field: int64 expected_tip_cents = 31;
   */
  expectedTipCents: bigint;

  /**
   * @generated from field: int64 tip_paid_cents = 32;
   */
  tipPaidCents: bigint;
};

/**
 * Describes the message cortado.v1.PublicPaymentSchedule.
 * Use `create(PublicPaymentScheduleSchema)` to create a new message.
 */
export const PublicPaymentScheduleSchema: GenMessage<PublicPaymentSchedule> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 19);

/**
 * PublicPaymentIntent is a customer-facing representation of a payment
 * Used in the portal to show payment history
 *
 * @generated from message cortado.v1.PublicPaymentIntent
 */
export type PublicPaymentIntent = Message<"cortado.v1.PublicPaymentIntent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: int64 amount_cents = 2;
   */
  amountCents: bigint;

  /**
   * @generated from field: cortado.v1.PaymentIntentStatusEnum status = 3;
   */
  status: PaymentIntentStatusEnum;

  /**
   * @generated from field: optional google.protobuf.Timestamp paid_at = 4;
   */
  paidAt?: Timestamp;

  /**
   * Payment method display info
   *
   * "card", etc.
   *
   * @generated from field: optional string payment_method_type = 10;
   */
  paymentMethodType?: string;

  /**
   * "4242"
   *
   * @generated from field: optional string payment_method_last4 = 11;
   */
  paymentMethodLast4?: string;

  /**
   * "visa", "mastercard"
   *
   * @generated from field: optional string payment_method_brand = 12;
   */
  paymentMethodBrand?: string;
};

/**
 * Describes the message cortado.v1.PublicPaymentIntent.
 * Use `create(PublicPaymentIntentSchema)` to create a new message.
 */
export const PublicPaymentIntentSchema: GenMessage<PublicPaymentIntent> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 20);

/**
 * GeneratePortalLinkRequest is the request to generate a shareable portal link
 *
 * @generated from message cortado.v1.GeneratePortalLinkRequest
 */
export type GeneratePortalLinkRequest = Message<"cortado.v1.GeneratePortalLinkRequest"> & {
  /**
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;

  /**
   * Retained for compatibility; new links use a fixed 30-day lifetime
   *
   * @generated from field: optional int64 expires_in_hours = 2 [deprecated = true];
   * @deprecated
   */
  expiresInHours?: bigint;

  /**
   * Legacy: true maps to anonymous; false maps to recipient
   *
   * @generated from field: bool omit_token = 3 [deprecated = true];
   * @deprecated
   */
  omitToken: boolean;

  /**
   * @generated from field: optional cortado.v1.PortalAttributionModeEnum attribution_mode = 4;
   */
  attributionMode?: PortalAttributionModeEnum;

  /**
   * Optional quote deep link and reporting source
   *
   * @generated from field: optional string quote_id = 5;
   */
  quoteId?: string;
};

/**
 * Describes the message cortado.v1.GeneratePortalLinkRequest.
 * Use `create(GeneratePortalLinkRequestSchema)` to create a new message.
 */
export const GeneratePortalLinkRequestSchema: GenMessage<GeneratePortalLinkRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 21);

/**
 * GeneratePortalLinkResponse contains the generated portal link and token
 *
 * @generated from message cortado.v1.GeneratePortalLinkResponse
 */
export type GeneratePortalLinkResponse = Message<"cortado.v1.GeneratePortalLinkResponse"> & {
  /**
   * Full portal URL; short alias when enabled, legacy token query otherwise
   *
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * JWT retained for wire compatibility; never embedded in short URLs
   *
   * @generated from field: string token = 2 [deprecated = true];
   * @deprecated
   */
  token: string;

  /**
   * When the token or short alias expires (30 days after issuance)
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 3;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.GeneratePortalLinkResponse.
 * Use `create(GeneratePortalLinkResponseSchema)` to create a new message.
 */
export const GeneratePortalLinkResponseSchema: GenMessage<GeneratePortalLinkResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 22);

/**
 * GeneratePublicPortalLinkRequest generates a new portal link from an existing portal token
 * Called from customer portal (requires portal token auth, not Supabase auth)
 *
 * No inquiry_id needed - extracted from portal token claims
 *
 * @generated from message cortado.v1.GeneratePublicPortalLinkRequest
 */
export type GeneratePublicPortalLinkRequest = Message<"cortado.v1.GeneratePublicPortalLinkRequest"> & {
};

/**
 * Describes the message cortado.v1.GeneratePublicPortalLinkRequest.
 * Use `create(GeneratePublicPortalLinkRequestSchema)` to create a new message.
 */
export const GeneratePublicPortalLinkRequestSchema: GenMessage<GeneratePublicPortalLinkRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 23);

/**
 * GeneratePublicPortalLinkResponse contains the generated portal link
 *
 * @generated from message cortado.v1.GeneratePublicPortalLinkResponse
 */
export type GeneratePublicPortalLinkResponse = Message<"cortado.v1.GeneratePublicPortalLinkResponse"> & {
  /**
   * Full portal URL; short alias when enabled, legacy token query otherwise
   *
   * @generated from field: string url = 1;
   */
  url: string;

  /**
   * When the token expires (30 days after issuance)
   *
   * @generated from field: google.protobuf.Timestamp expires_at = 2;
   */
  expiresAt?: Timestamp;
};

/**
 * Describes the message cortado.v1.GeneratePublicPortalLinkResponse.
 * Use `create(GeneratePublicPortalLinkResponseSchema)` to create a new message.
 */
export const GeneratePublicPortalLinkResponseSchema: GenMessage<GeneratePublicPortalLinkResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 24);

/**
 * SharePublicInquiryByEmailRequest sends inquiry link to multiple email addresses
 * Called from customer portal.
 *
 * @generated from message cortado.v1.SharePublicInquiryByEmailRequest
 */
export type SharePublicInquiryByEmailRequest = Message<"cortado.v1.SharePublicInquiryByEmailRequest"> & {
  /**
   * Email addresses to send to
   *
   * @generated from field: repeated string emails = 1;
   */
  emails: string[];

  /**
   * Inquiry to share
   *
   * @generated from field: string inquiry_id = 2;
   */
  inquiryId: string;
};

/**
 * Describes the message cortado.v1.SharePublicInquiryByEmailRequest.
 * Use `create(SharePublicInquiryByEmailRequestSchema)` to create a new message.
 */
export const SharePublicInquiryByEmailRequestSchema: GenMessage<SharePublicInquiryByEmailRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 25);

/**
 * SharePublicInquiryByEmailResponse indicates success
 *
 * @generated from message cortado.v1.SharePublicInquiryByEmailResponse
 */
export type SharePublicInquiryByEmailResponse = Message<"cortado.v1.SharePublicInquiryByEmailResponse"> & {
  /**
   * Number of emails queued for sending
   *
   * @generated from field: int32 emails_queued = 1;
   */
  emailsQueued: number;
};

/**
 * Describes the message cortado.v1.SharePublicInquiryByEmailResponse.
 * Use `create(SharePublicInquiryByEmailResponseSchema)` to create a new message.
 */
export const SharePublicInquiryByEmailResponseSchema: GenMessage<SharePublicInquiryByEmailResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 26);

/**
 * SharePublicInvoiceByEmailRequest sends invoice link to multiple email addresses
 * Called from customer portal.
 *
 * @generated from message cortado.v1.SharePublicInvoiceByEmailRequest
 */
export type SharePublicInvoiceByEmailRequest = Message<"cortado.v1.SharePublicInvoiceByEmailRequest"> & {
  /**
   * Invoice to share
   *
   * @generated from field: string invoice_id = 1;
   */
  invoiceId: string;

  /**
   * Email addresses to send to
   *
   * @generated from field: repeated string emails = 2;
   */
  emails: string[];
};

/**
 * Describes the message cortado.v1.SharePublicInvoiceByEmailRequest.
 * Use `create(SharePublicInvoiceByEmailRequestSchema)` to create a new message.
 */
export const SharePublicInvoiceByEmailRequestSchema: GenMessage<SharePublicInvoiceByEmailRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 27);

/**
 * SharePublicInvoiceByEmailResponse indicates success
 *
 * @generated from message cortado.v1.SharePublicInvoiceByEmailResponse
 */
export type SharePublicInvoiceByEmailResponse = Message<"cortado.v1.SharePublicInvoiceByEmailResponse"> & {
  /**
   * Number of emails queued for sending
   *
   * @generated from field: int32 emails_queued = 1;
   */
  emailsQueued: number;
};

/**
 * Describes the message cortado.v1.SharePublicInvoiceByEmailResponse.
 * Use `create(SharePublicInvoiceByEmailResponseSchema)` to create a new message.
 */
export const SharePublicInvoiceByEmailResponseSchema: GenMessage<SharePublicInvoiceByEmailResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 28);

/**
 * CreateBookingRequest is the request to create a new booking directly (without inquiry)
 *
 * @generated from message cortado.v1.CreateBookingRequest
 */
export type CreateBookingRequest = Message<"cortado.v1.CreateBookingRequest"> & {
  /**
   * Organization ID the booking belongs to
   *
   * @generated from field: string organization_id = 1;
   */
  organizationId: string;

  /**
   * Contact ID associated with the booking (required)
   *
   * @generated from field: string contact_id = 2;
   */
  contactId: string;

  /**
   * Type of event (optional)
   *
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 3 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional string event_type_key = 5;
   */
  eventTypeKey?: string;
};

/**
 * Describes the message cortado.v1.CreateBookingRequest.
 * Use `create(CreateBookingRequestSchema)` to create a new message.
 */
export const CreateBookingRequestSchema: GenMessage<CreateBookingRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 29);

/**
 * CreateBookingResponse contains the created booking
 *
 * @generated from message cortado.v1.CreateBookingResponse
 */
export type CreateBookingResponse = Message<"cortado.v1.CreateBookingResponse"> & {
  /**
   * @generated from field: cortado.v1.Booking booking = 1;
   */
  booking?: Booking;
};

/**
 * Describes the message cortado.v1.CreateBookingResponse.
 * Use `create(CreateBookingResponseSchema)` to create a new message.
 */
export const CreateBookingResponseSchema: GenMessage<CreateBookingResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 30);

/**
 * GetInquiryOverlapsRequest is the request to get overlapping leads and events for an inquiry
 *
 * @generated from message cortado.v1.GetInquiryOverlapsRequest
 */
export type GetInquiryOverlapsRequest = Message<"cortado.v1.GetInquiryOverlapsRequest"> & {
  /**
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;
};

/**
 * Describes the message cortado.v1.GetInquiryOverlapsRequest.
 * Use `create(GetInquiryOverlapsRequestSchema)` to create a new message.
 */
export const GetInquiryOverlapsRequestSchema: GenMessage<GetInquiryOverlapsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 31);

/**
 * GetInquiryOverlapsResponse contains inquiries and events that overlap with the requested inquiry's date/time
 *
 * @generated from message cortado.v1.GetInquiryOverlapsResponse
 */
export type GetInquiryOverlapsResponse = Message<"cortado.v1.GetInquiryOverlapsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.InquiryLite overlapping_inquiries = 1;
   */
  overlappingInquiries: InquiryLite[];

  /**
   * @generated from field: repeated cortado.v1.EventLite overlapping_events = 2;
   */
  overlappingEvents: EventLite[];
};

/**
 * Describes the message cortado.v1.GetInquiryOverlapsResponse.
 * Use `create(GetInquiryOverlapsResponseSchema)` to create a new message.
 */
export const GetInquiryOverlapsResponseSchema: GenMessage<GetInquiryOverlapsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 32);

/**
 * CreateInquiryEventRequest creates a new inquiry event
 *
 * @generated from message cortado.v1.CreateInquiryEventRequest
 */
export type CreateInquiryEventRequest = Message<"cortado.v1.CreateInquiryEventRequest"> & {
  /**
   * Inquiry ID to add the event to (required)
   *
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;

  /**
   * Date of the event (optional - may not be set initially)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 2;
   */
  eventDate?: Timestamp;

  /**
   * Length of the event in hours (optional)
   *
   * @generated from field: optional double event_length = 3;
   */
  eventLength?: number;

  /**
   * Number of guests (optional)
   *
   * @generated from field: optional int32 event_guests = 4;
   */
  eventGuests?: number;

  /**
   * Timezone of the event (optional)
   *
   * @generated from field: optional string event_timezone = 5;
   */
  eventTimezone?: string;

  /**
   * Type of event (optional)
   *
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 6 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * @generated from field: optional string event_type_key = 10;
   */
  eventTypeKey?: string;

  /**
   * Location of the event (optional)
   *
   * @generated from field: optional string event_location = 7;
   */
  eventLocation?: string;

  /**
   * Number of baristas needed (optional) - for resource planning
   *
   * @generated from field: optional int32 barista_count = 8;
   */
  baristaCount?: number;

  /**
   * Number of carts needed (optional) - for resource planning
   *
   * @generated from field: optional int32 cart_count = 9;
   */
  cartCount?: number;
};

/**
 * Describes the message cortado.v1.CreateInquiryEventRequest.
 * Use `create(CreateInquiryEventRequestSchema)` to create a new message.
 */
export const CreateInquiryEventRequestSchema: GenMessage<CreateInquiryEventRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 33);

/**
 * CreateInquiryEventResponse contains the created inquiry event
 *
 * @generated from message cortado.v1.CreateInquiryEventResponse
 */
export type CreateInquiryEventResponse = Message<"cortado.v1.CreateInquiryEventResponse"> & {
  /**
   * @generated from field: cortado.v1.InquiryEvent inquiry_event = 1;
   */
  inquiryEvent?: InquiryEvent;
};

/**
 * Describes the message cortado.v1.CreateInquiryEventResponse.
 * Use `create(CreateInquiryEventResponseSchema)` to create a new message.
 */
export const CreateInquiryEventResponseSchema: GenMessage<CreateInquiryEventResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 34);

/**
 * UpdateInquiryEventRequest updates an existing inquiry event
 *
 * @generated from message cortado.v1.UpdateInquiryEventRequest
 */
export type UpdateInquiryEventRequest = Message<"cortado.v1.UpdateInquiryEventRequest"> & {
  /**
   * Inquiry event ID to update (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Date of the event (optional)
   *
   * @generated from field: optional google.protobuf.Timestamp event_date = 2;
   */
  eventDate?: Timestamp;

  /**
   * Length of the event in hours (optional)
   *
   * @generated from field: optional double event_length = 3;
   */
  eventLength?: number;

  /**
   * Number of guests (optional)
   *
   * @generated from field: optional int32 event_guests = 4;
   */
  eventGuests?: number;

  /**
   * Timezone of the event (optional)
   *
   * @generated from field: optional string event_timezone = 5;
   */
  eventTimezone?: string;

  /**
   * Type of event (optional)
   *
   * @generated from field: optional cortado.v1.EventTypeEnum event_type = 6 [deprecated = true];
   * @deprecated
   */
  eventType?: EventTypeEnum;

  /**
   * Location of the event (optional)
   *
   * @generated from field: optional string event_location = 7;
   */
  eventLocation?: string;

  /**
   * Field mask for partial updates
   *
   * @generated from field: google.protobuf.FieldMask update_mask = 8;
   */
  updateMask?: FieldMask;

  /**
   * Number of baristas needed (optional) - for resource planning
   *
   * @generated from field: optional int32 barista_count = 9;
   */
  baristaCount?: number;

  /**
   * Number of carts needed (optional) - for resource planning
   *
   * @generated from field: optional int32 cart_count = 10;
   */
  cartCount?: number;

  /**
   * @generated from field: optional string event_type_key = 11;
   */
  eventTypeKey?: string;
};

/**
 * Describes the message cortado.v1.UpdateInquiryEventRequest.
 * Use `create(UpdateInquiryEventRequestSchema)` to create a new message.
 */
export const UpdateInquiryEventRequestSchema: GenMessage<UpdateInquiryEventRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 35);

/**
 * UpdateInquiryEventResponse contains the updated inquiry event
 *
 * @generated from message cortado.v1.UpdateInquiryEventResponse
 */
export type UpdateInquiryEventResponse = Message<"cortado.v1.UpdateInquiryEventResponse"> & {
  /**
   * @generated from field: cortado.v1.InquiryEvent inquiry_event = 1;
   */
  inquiryEvent?: InquiryEvent;
};

/**
 * Describes the message cortado.v1.UpdateInquiryEventResponse.
 * Use `create(UpdateInquiryEventResponseSchema)` to create a new message.
 */
export const UpdateInquiryEventResponseSchema: GenMessage<UpdateInquiryEventResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 36);

/**
 * DeleteInquiryEventRequest deletes an inquiry event
 *
 * @generated from message cortado.v1.DeleteInquiryEventRequest
 */
export type DeleteInquiryEventRequest = Message<"cortado.v1.DeleteInquiryEventRequest"> & {
  /**
   * Inquiry event ID to delete (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.DeleteInquiryEventRequest.
 * Use `create(DeleteInquiryEventRequestSchema)` to create a new message.
 */
export const DeleteInquiryEventRequestSchema: GenMessage<DeleteInquiryEventRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 37);

/**
 * DeleteInquiryEventResponse confirms the deletion
 *
 * @generated from message cortado.v1.DeleteInquiryEventResponse
 */
export type DeleteInquiryEventResponse = Message<"cortado.v1.DeleteInquiryEventResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.DeleteInquiryEventResponse.
 * Use `create(DeleteInquiryEventResponseSchema)` to create a new message.
 */
export const DeleteInquiryEventResponseSchema: GenMessage<DeleteInquiryEventResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 38);

/**
 * ListInquiryEventsRequest lists inquiry events for an inquiry
 *
 * @generated from message cortado.v1.ListInquiryEventsRequest
 */
export type ListInquiryEventsRequest = Message<"cortado.v1.ListInquiryEventsRequest"> & {
  /**
   * Inquiry ID to list events for (required)
   *
   * @generated from field: string inquiry_id = 1;
   */
  inquiryId: string;
};

/**
 * Describes the message cortado.v1.ListInquiryEventsRequest.
 * Use `create(ListInquiryEventsRequestSchema)` to create a new message.
 */
export const ListInquiryEventsRequestSchema: GenMessage<ListInquiryEventsRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 39);

/**
 * ListInquiryEventsResponse contains the list of inquiry events
 *
 * @generated from message cortado.v1.ListInquiryEventsResponse
 */
export type ListInquiryEventsResponse = Message<"cortado.v1.ListInquiryEventsResponse"> & {
  /**
   * @generated from field: repeated cortado.v1.InquiryEvent inquiry_events = 1;
   */
  inquiryEvents: InquiryEvent[];
};

/**
 * Describes the message cortado.v1.ListInquiryEventsResponse.
 * Use `create(ListInquiryEventsResponseSchema)` to create a new message.
 */
export const ListInquiryEventsResponseSchema: GenMessage<ListInquiryEventsResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 40);

/**
 * ArchiveEventRequest is the request to soft-delete an event
 *
 * @generated from message cortado.v1.ArchiveEventRequest
 */
export type ArchiveEventRequest = Message<"cortado.v1.ArchiveEventRequest"> & {
  /**
   * Event ID to archive (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.ArchiveEventRequest.
 * Use `create(ArchiveEventRequestSchema)` to create a new message.
 */
export const ArchiveEventRequestSchema: GenMessage<ArchiveEventRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 41);

/**
 * ArchiveEventResponse confirms the archive operation
 *
 * @generated from message cortado.v1.ArchiveEventResponse
 */
export type ArchiveEventResponse = Message<"cortado.v1.ArchiveEventResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.ArchiveEventResponse.
 * Use `create(ArchiveEventResponseSchema)` to create a new message.
 */
export const ArchiveEventResponseSchema: GenMessage<ArchiveEventResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 42);

/**
 * UnarchiveEventRequest is the request to restore an archived event
 *
 * @generated from message cortado.v1.UnarchiveEventRequest
 */
export type UnarchiveEventRequest = Message<"cortado.v1.UnarchiveEventRequest"> & {
  /**
   * Event ID to unarchive (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.UnarchiveEventRequest.
 * Use `create(UnarchiveEventRequestSchema)` to create a new message.
 */
export const UnarchiveEventRequestSchema: GenMessage<UnarchiveEventRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 43);

/**
 * UnarchiveEventResponse confirms the unarchive operation
 *
 * @generated from message cortado.v1.UnarchiveEventResponse
 */
export type UnarchiveEventResponse = Message<"cortado.v1.UnarchiveEventResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.UnarchiveEventResponse.
 * Use `create(UnarchiveEventResponseSchema)` to create a new message.
 */
export const UnarchiveEventResponseSchema: GenMessage<UnarchiveEventResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 44);

/**
 * ArchiveInquiryRequest is the request to soft-delete an inquiry (lead)
 *
 * @generated from message cortado.v1.ArchiveInquiryRequest
 */
export type ArchiveInquiryRequest = Message<"cortado.v1.ArchiveInquiryRequest"> & {
  /**
   * Inquiry ID to archive (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * When true, also archive the events belonging to this inquiry's booking.
   * Opt-in per archive action; archiving an inquiry never cascades by default.
   *
   * @generated from field: bool cascade_events = 2;
   */
  cascadeEvents: boolean;
};

/**
 * Describes the message cortado.v1.ArchiveInquiryRequest.
 * Use `create(ArchiveInquiryRequestSchema)` to create a new message.
 */
export const ArchiveInquiryRequestSchema: GenMessage<ArchiveInquiryRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 45);

/**
 * ArchiveInquiryResponse confirms the archive operation
 *
 * @generated from message cortado.v1.ArchiveInquiryResponse
 */
export type ArchiveInquiryResponse = Message<"cortado.v1.ArchiveInquiryResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.ArchiveInquiryResponse.
 * Use `create(ArchiveInquiryResponseSchema)` to create a new message.
 */
export const ArchiveInquiryResponseSchema: GenMessage<ArchiveInquiryResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 46);

/**
 * UnarchiveInquiryRequest is the request to restore an archived inquiry (lead)
 *
 * @generated from message cortado.v1.UnarchiveInquiryRequest
 */
export type UnarchiveInquiryRequest = Message<"cortado.v1.UnarchiveInquiryRequest"> & {
  /**
   * Inquiry ID to unarchive (required)
   *
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message cortado.v1.UnarchiveInquiryRequest.
 * Use `create(UnarchiveInquiryRequestSchema)` to create a new message.
 */
export const UnarchiveInquiryRequestSchema: GenMessage<UnarchiveInquiryRequest> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 47);

/**
 * UnarchiveInquiryResponse confirms the unarchive operation
 *
 * @generated from message cortado.v1.UnarchiveInquiryResponse
 */
export type UnarchiveInquiryResponse = Message<"cortado.v1.UnarchiveInquiryResponse"> & {
  /**
   * @generated from field: string message = 1;
   */
  message: string;
};

/**
 * Describes the message cortado.v1.UnarchiveInquiryResponse.
 * Use `create(UnarchiveInquiryResponseSchema)` to create a new message.
 */
export const UnarchiveInquiryResponseSchema: GenMessage<UnarchiveInquiryResponse> = /*@__PURE__*/
  messageDesc(file_cortado_v1_inquiries, 48);

